<template>
  <div>
    <section v-if="loading">
      <div class="loader"></div>
    </section>
    <section v-else>
      <div
          v-if="(datatableId==='currentOutages' || datatableId === 'currentZabbixOutages') && tableType !== 'suspended'"
          class="row group-section mb-1">
        <template>
          <div class="col-md-6 lh-3">
            <template>
              Down Services: <span class="badge badge-danger mr-2">{{ totalDownServices }}</span>
              Down Sites: <span class="badge badge-danger mr-2">{{ totalDownTests }}</span>
              Paused: <span class="badge badge-warning mr-2">{{ totalPausedTests }}</span>
              Pending: <span class="badge badge-default mr-2">{{ totalPendingTests }}</span>
              Suspended: <span class="badge badge-info mr-2">{{ totalSuspendedTests }}</span>
              Total: <span class="badge badge-success"> {{ tests.length }}</span>
            </template>
          </div>
          <div class="col-md-3 lh-3 text-center">
            Affected Nodes:
            <button class="btn btn-primary btn-sm mr-3 text-right" title="View nodes"
                    @click="openAffectedNodesAndRacksModal('node')"><i class="fa fa-eye"></i></button>

          </div>
          <div class="col-md-3 lh-3 text-right">
            Affected Racks:
            <button class="btn btn-primary btn-sm mr-3 text-right" title="View racks"
                    @click="openAffectedNodesAndRacksModal('rack')"><i class="fa fa-eye"></i></button>

          </div>


        </template>
      </div>
      <div v-for="group in getSuspendedGroup" v-if="tableType === 'suspended'" :key="group.planName"
           class="row group-section mb-1">
        <template>
          <div class="col-md-1">
            <span :class="{ 'details-control shown' : group.showTests, 'details-control' : !group.showTests }"
                  @click="renderDatatable(group, 'openedGroups')"></span>
          </div>
          <div class="col-md-7 lh-3">
            <b>
              <span>{{ group.planName === 'Suspended' ? 'Suspended' : group.planName }}</span>
            </b>
            <!--            <span class="ml-1" v-if="group.planName !== '(N/A)'">-->
            <!--						Server IP:-->
            <!--            <b>{{group.serverIp}}</b>-->
            <!--            </span>-->
          </div>
          <div class="col-md-4 text-right lh-3">
            <template v-if="status === 'Down'">
              <span class="badge badge-danger mr-2 cursor-pointer" title="Down">{{ group.downCount }}</span>
              <span class="badge badge-warning mr-2 cursor-pointer" title="Paused">{{ group.pauseCount }}</span>
              <span class="badge badge-success cursor-pointer" title="Total"> {{ group.tests.length }}</span>
            </template>
            <template v-else>
              <span class="badge badge-success cursor-pointer"
                    title="Total Recent Outages"> {{ group.tests.length }}</span>

              <!--              Total Recent Outages: <b>{{group.tests.length}}</b>-->
            </template>
            <!--						<button v-if="group.uid"  class="btn btn-primary btn-sm mr-3 ml-3 text-right" title="Login User" @click="findUser(group)"><i class="fa fa-user"></i></button>-->
            <!--						<router-link v-if="group.uid"  class="btn btn-primary btn-sm text-right"  title="Edit User" :to="{ name: 'editUser', params: { docID: group.uid } }"><i class="fa fa-pencil"></i></router-link>-->
          </div>
          <div v-show="group.showTests" class="col-md-12">
            <table
                :id="group.planName==='Suspended' ? `${datatableId}-suspended` : `${datatableId}-${group.planName.split('.')[0]}`"
                class="table table-striped single-outage-table table-responsive">
              <thead>
              <tr class="text-center">
                <th></th>
                <!--								<th>Test ID</th>-->
                <th>Status</th>
                <th>Tags</th>
                <th>Test Name</th>
                <th>Server IP</th>
                <th>Down Time</th>
                <th>Out ages</th>
                <!--								<th>Status Code</th>-->
                <!--								<th>Uptime</th>-->
                <th width="11%">Note</th>
                <th>Ticket</th>
                <th>Node</th>
                <th>Rack</th>
                <th>Test</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(test, index) in group.tests" :key="test.id" :data-id="test.id">
                <td width="1%">
                  <div class="dropdown m-auto">
                    <button id="dropdownMenuButton1" aria-expanded="false"
                            aria-haspopup="true" class="btn settinds-btn btn-sm dropdown-toggle" data-toggle="dropdown"
                            style="width: 15px!important; padding: 0!important;" title="Choose Operation" type="button">
                      <i class="fa fa-cog"></i>
                    </button>
                    <div aria-labelledby="dropdownMenuButton1" class="dropdown-menu">
                      <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'viewEventsModal')">View
                        Details</a>
                      <a class="dropdown-item" href="javascript:void(0)" @click="redirectToGraph(test)">View Graph</a>
                      <a class="dropdown-item" href="javascript:void(0)" @click="removeZabbixMonitor(test, group)">Delete</a>
                      <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'addNoteModal')">Add
                        Notes</a>
                      <a v-if="group.uid" class="dropdown-item" href="javascript:void(0)" @click="findUser(group)">Login
                        User</a>
                      <a v-if="group.uid" class="dropdown-item" href="javascript:void(0)"
                         @click="openTicketModal(test)">Create Ticket</a>
                      <router-link v-if="group.uid" :to="{ name: 'editUser', params: { docID: group.uid || test.uid } }"
                                   class="dropdown-item">Edit User
                      </router-link>

                    </div>
                  </div>
                </td>
                <td class="text-center" width="1%">
                  <div
                      :class="{'sc-status': true, 'down': test.status === 'down', 'up': test.status === 'up', 'pause': test.status === 'paused', 'pending': test.status === 'pending'}"
                      @click="openModal(test, 'changeLiveStatusModal')"></div>
                </td>
                <td width="1%">

                </td>
                <td class="text-center domain" width="20%">
                  <div>
                    <a :href="getEffectiveUrl(test)" target="_blank">
                      {{ showDomainName(test.url) }}
                      <!--                      {{// test.url.includes('https://') ? test.url.split('https://')[1] : test.url}}-->
                    </a>
                    <span v-if="checkActiveJob(test)" :key="testindex + index +'active112'"
                          :title="getActiveJobTitle(test)"
                          class="cursor-pointer" data-html="true" data-placement="top"
                          data-toggle="tooltip">⚠️</span>
                    <span v-if="checkPhpJob(test)" :key="testindex+index+'php113'" :title="getPhpJobTitle(test)"
                          class="cursor-pointer" data-html="true" data-placement="top" data-toggle="tooltip">
                      <img height="25" src="../../../assets/img/php-job.png">
                    </span>
                    <span v-if="checkCompletedJob(test)" :key="test+'completeJob'" :title="getCompletedJobTitle(test)"
                          class="cursor-pointer" data-html="true" data-placement="top" data-toggle="tooltip">⚠️<i
                        class="fa fa-check text-success"></i></span>
                  </div>
                </td>
                <td class="text-center" width="3%" @click="doCopy(test.serverIP)">{{ test.serverIP }}</td>
                <template v-if="status === 'up'">
                  <td class="text-center" width="3%">
                    {{
                      timeDifferenceBetweenGivenDates(test.incidents[test.incidents.length - 1].start, test.incidents[test.incidents.length - 2].start)
                    }}
                  </td>
                </template>
                <template v-else>
                  <td class="text-center" width="3%">
                    {{ domainDateTime[test.url] }}
                  </td>
                </template>
                <td class="text-center" width="1%">{{ test.downCount }}</td>
                <!--								<td class="text-center">{{test.events[test.events.length-1].statusCode}}</td>-->
                <!--								<td class="text-center">{{test.upTime}}</td>-->
                <td :key="test.id+'addNoteModal'" :title="test.note" class="cursor-pointer domain"
                    data-html="true" data-placement="top" data-toggle="tooltip" width="13%"
                    @click="openModal(test, 'addNoteModal')">{{ (test.note && test.note !== '') ? test.note : 'N/A' }}
                </td>
                <td class="text-center" width="3%">
                  <i :key="test.id+'editTicket1'" class="text-primary fa fa-pencil cursor-pointer" data-html="true"
                     data-placement="top" data-toggle="tooltip" title="Edit ticket"
                     @click="openModal(test, 'addTicketModal')"></i>
                  <a v-if="test.ticket_url" :href="test.ticket_url" target="_blank">
                    <i :class="test.ticket_url ? 'text-primary' : 'text-muted'" class=" fa fa-eye ml-2"
                       title="View Ticket"></i>
                  </a>
                </td>
                <td class="text-center text-uppercase" width="3%">
                  {{ (allNodes[`${test.netboxNodeId}`]) ? allNodes[`${test.netboxNodeId}`].name || '' : '' }}
                </td>
                <td class="text-center text-uppercase" width="2%">
                  {{
                    (allNodes[`${test.netboxNodeId}`]) ? (allNodes[`${test.netboxNodeId}`].rack ? allNodes[`${test.netboxNodeId}`].rack.name : '') : ''
                  }}
                </td>
                <td width="10%">
                  <select :key="test.id" class="form-control" style="height: 31px; min-width: 70px; max-width: 190px"
                          @change="updateStatusCakeValue(test, $event)">
                    <option></option>
                    <option
                        :selected="(test.statusCake === undefined && (test.status === 'up' || test.status === 'down')) ? true : test.statusCake === 'Active'"
                        value="Active">Active
                    </option>
                    <option :selected="test.statusCake === 'Moved'" value="Moved">Moved</option>
                    <option
                        :selected="(test.statusCake === undefined && test.status === 'paused ') ? true : test.statusCake === 'Suspended'"
                        value="Suspended">Suspended
                    </option>
                    <option :selected="test.statusCake === 'Domain Expired'" value="Domain Expired">Domain Expired
                    </option>
                    <option :selected="test.statusCake === 'Other'" value="Other">Other</option>
                  </select>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </template>
        <div v-if="getSuspendedGroup.length === 0" class="customer-list-info col-md-12">
          <div class="card-text text-center text-danger mb-3 font-weight-bold">
            No Suspended Outages Exists!
          </div>
        </div>
      </div>
      <div v-for="group in getNonWPOGroup" v-if="tableType !== 'suspended'" :key="group.planName"
           class="row group-section mb-1">
        <template>
          <div class="col-md-1">
            <span :class="{ 'details-control shown' : group.showTests, 'details-control' : !group.showTests }"
                  @click="renderDatatable(group, 'openedGroups')"></span>
          </div>
          <div class="col-md-7 lh-3">
            <b>
              <span>{{ group.planName === '(N/A)' ? 'Not in WPO' : group.planName }}</span>
            </b>
            <span v-if="group.planName !== '(N/A)'" class="ml-1">
          Server IP:
          <b>{{ group.serverIp }}</b>
          </span>
          </div>
          <!--					<div class="col-md-4 text-center lh-3">-->
          <!--						<template  v-if="status === 'Down'">-->
          <!--							Down: <span class="badge badge-danger mr-3">{{group.downCount}}</span>-->
          <!--							Paused: <span class="badge badge-warning mr-3">{{group.pauseCount}}</span>-->
          <!--							Total: <span class="badge badge-success"> {{group.tests.length}}</span>-->
          <!--						</template>-->
          <!--						<template v-else>-->
          <!--							Total Recent Outages: <b>{{group.tests.length}}</b>-->
          <!--						</template>-->
          <!--					</div>-->
          <div class="col-md-4 text-right lh-3">
            <template v-if="status === 'Down'">
              <span class="badge badge-danger mr-2 cursor-pointer" title="Down">{{ group.downCount }}</span>
              <span class="badge badge-warning mr-2 cursor-pointer" title="Paused">{{ group.pauseCount }}</span>
              <span class="badge badge-success cursor-pointer" title="Total"> {{ group.tests.length }}</span>
            </template>
            <template v-else>
              <span class="badge badge-success cursor-pointer"
                    title="Total Recent Outages"> {{ group.tests.length }}</span>

              <!--              Total Recent Outages: <b>{{group.tests.length}}</b>-->
            </template>
            <!--						<button v-if="group.uid"  class="btn btn-primary btn-sm mr-3 ml-3 text-right" title="Login User" @click="findUser(group)"><i class="fa fa-user"></i></button>-->
            <!--						<router-link v-if="group.uid"  class="btn btn-primary btn-sm text-right"  title="Edit User" :to="{ name: 'editUser', params: { docID: group.uid } }"><i class="fa fa-pencil"></i></router-link>-->
          </div>
          <div v-show="group.showTests" class="col-md-12">
            <table
                :id="group.planName==='(N/A)' ? `${datatableId}-unavailable` : `${datatableId}-${group.planName.split('.')[0]}`"
                class="table table-striped single-outage-table table-responsive">
              <thead>
              <tr class="text-center">
                <th></th>
                <!--								<th>Test ID</th>-->
                <th>Status</th>
                <th>Tags</th>
                <th>Test Name</th>
                <th>Server IP</th>
                <th>Down Time</th>
                <th>Out ages</th>
                <!--								<th>Status Code</th>-->
                <!--								<th>Uptime</th>-->
                <th width="11%">Note</th>
                <th>Ticket</th>
                <th>Node</th>
                <th>Rack</th>
                <th>Test</th>
                <th width="7%">Acknowledge</th>

                <!--								<th width="12%">Action</th>-->
              </tr>
              </thead>
              <tbody>
              <tr v-for="test in group.tests" :key="test.id" :data-id="test.id">
                <td width="1%">
                  <div class="dropdown m-auto">
                    <button id="dropdownMenuButton1" aria-expanded="false"
                            aria-haspopup="true" class="btn settinds-btn btn-sm dropdown-toggle" data-toggle="dropdown"
                            style="width: 15px!important; padding: 0!important;" title="Choose Operation" type="button">
                      <i class="fa fa-cog"></i>
                    </button>
                    <div aria-labelledby="dropdownMenuButton1" class="dropdown-menu">
                      <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'viewEventsModal')">View
                        Details</a>
                      <a class="dropdown-item" href="javascript:void(0)" @click="redirectToGraph(test)">View Graph</a>
                      <a class="dropdown-item" href="javascript:void(0)" @click="remove(test, group)">Delete</a>
                      <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'addNoteModal')">Add
                        Notes</a>
                      <a v-if="group.uid" class="dropdown-item" href="javascript:void(0)" @click=" findUser(group)">Login
                        User</a>
                      <a v-if="group.uid" class="dropdown-item" href="javascript:void(0)"
                         @click=" openTicketModal(test)">Create Ticket</a>
                      <router-link v-if="group.uid" :to="{ name: 'editUser', params: { docID: group.uid || test.uid } }"
                                   class="dropdown-item">Edit User
                      </router-link>

                    </div>
                  </div>
                </td>
                <!--								<td width="3%">-->
                <!--									<button class="btn btn-info btn-sm" @click="openModal(test, 'viewEventsModal')"><i class="fa fa-eye"></i></button>-->
                <!--								</td>-->
                <!--								<td class="text-center">{{ test.testId }}</td>-->
                <td class="text-center" width="1%">
                  <div
                      :class="{'sc-status': true, 'down': test.status === 'down', 'up': test.status === 'up', 'pause': test.status === 'paused', 'pending': test.status === 'pending'}"
                      @click="openModal(test, 'changeLiveStatusModal')"></div>
                </td>
                <td>

                </td>
                <td class="text-center domain" width="20%">
                  <div>
                    <a :href="getEffectiveUrl(test)" target="_blank">
                      {{ showDomainName(test.url) }}
                      <!--                      {{// test.url.includes('https://') ? test.url.split('https://')[1] : test.url}}-->
                    </a>
                    <span v-if="checkActiveJob(test)" :key="testindex+index+'274active'"
                          :title="getActiveJobTitle(test)"
                          class="cursor-pointer" data-html="true" data-placement="top"
                          data-toggle="tooltip">⚠️</span>
                    <span v-if="checkPhpJob(test)" :key="testindex+index+'276php'" :title="getPhpJobTitle(test)"
                          class="cursor-pointer" data-html="true" data-placement="top" data-toggle="tooltip">
                      <img height="25" src="../../../assets/img/php-job.png">
                    </span>
                    <span v-if="checkCompletedJob(test)" :key="test+'completeJob'" :title="getCompletedJobTitle(test)"
                          class="cursor-pointer" data-html="true" data-placement="top" data-toggle="tooltip">⚠️<i
                        class="fa fa-check text-success"></i></span>
                  </div>
                </td>
                <td class="text-center" width="3%" @click="doCopy(test.serverIP)">{{ test.serverIP }}</td>
                <template v-if="status === 'up'">
                  <td class="text-center" width="3%">
                    {{
                      timeDifferenceBetweenGivenDates(test.incidents[test.incidents.length - 1].start, test.incidents[test.incidents.length - 2].start)
                    }}
                  </td>
                </template>
                <template v-else>
                  <td class="text-center" width="3%">
                    {{ domainDateTime[test.url] }}
                  </td>
                </template>
                <td class="text-center" width="1%">{{ test.zabbixDownCount }}</td>
                <!--								<td class="text-center">{{test.events[test.events.length-1].statusCode}}</td>-->
                <!--								<td class="text-center">{{test.upTime}}</td>-->
                <td :title="test.note" class="cursor-pointer domain" width="13%"
                    @click="openModal(test, 'addNoteModal')">{{ (test.note && test.note !== '') ? test.note : 'N/A' }}
                </td>
                <td class="text-center" width="3%">
                  <i class="text-primary fa fa-pencil cursor-pointer" title="Edit ticket"
                     @click="openModal(test, 'addTicketModal')"></i>
                  <a v-if="test.ticket_url" :href="test.ticket_url" target="_blank">
                    <i :class="test.ticket_url ? 'text-primary' : 'text-muted'" class=" fa fa-eye ml-2"
                       title="View Ticket"></i>
                  </a>
                </td>
                <td class="text-center text-uppercase" width="3%">
                  {{ (allNodes[`${test.netboxNodeId}`]) ? allNodes[`${test.netboxNodeId}`].name || '' : '' }}
                </td>
                <td class="text-center text-uppercase" width="2%">
                  {{
                    (allNodes[`${test.netboxNodeId}`]) ? (allNodes[`${test.netboxNodeId}`].rack ? allNodes[`${test.netboxNodeId}`].rack.name : '') : ''
                  }}
                </td>
                <td width="10%">
                  <select :key="test.id" class="form-control" style="height: 31px; min-width: 70px; max-width: 190px"
                          @change="updateStatusCakeValue(test, $event)">
                    <!--                    <option></option>-->
                    <option v-for="(row, index) in statusList" :key="index"
                            :selected="checkStatusCake(test, row.status)" :value="row.status">
                      {{ row.status }}
                    </option>
                    <!--                    <option :selected="(test.statusCake === undefined && (test.status === 'up' || test.status === 'down')) ? true : test.statusCake === 'Active'" value="Active">Active</option>-->
                    <!--                    <option :selected="test.statusCake === 'Moved'" value="Moved">Moved</option>-->
                    <!--                    <option :selected="(test.statusCake === undefined && test.status === 'paused ') ? true : test.statusCake === 'Suspended'" value="Suspended">Suspended</option>-->
                    <!--                    <option :selected="test.statusCake === 'Domain Expired'" value="Domain Expired">Domain Expired</option>-->
                    <!--                    <option :selected="test.statusCake === 'Other'" value="Other">Other</option>-->
                  </select>
                </td>
                <td width="2%">
                  <template v-if="test.acknowledgedBy">
                  <span class="badge badge-pill badge-success">
                      {{ (test.acknowledgedBy) }}
                    </span>
                  </template>
                  <button v-else-if="test.status === 'down'"
                          :disabled="selectedMonitorLoading && selectedMonitorLoading === test.id"
                          class="btn btn-primary btn-sm" type="button"
                          @click="acknowledge(test)">
                  <span v-if="selectedMonitorLoading && selectedMonitorLoading === test.id">
                    <div class="loader mini_loader"></div>
                  </span>
                    <span v-else>
                    Check In
                  </span>
                  </button>
                </td>
                <!--								<td width="12%" class="text-center">-->
                <!--									<button class="btn btn-warning btn-sm mr-1" :disabled="action" @click="pause(test ,1)">-->
                <!--										<div class="loader mini_loader" v-if="updateItem && test.testId === updateItem.testId && action === 'update'"></div>-->
                <!--										<i v-else class="fa fa-pause"></i>-->
                <!--									</button>-->
                <!--									<button class="btn btn-danger btn-sm mr-1" :disabled="action"  @click="remove(test)">-->
                <!--										<div class="loader mini_loader" v-if="removeItem && test.testId === removeItem.testId && action === 'remove'"></div>-->
                <!--										<i v-else class="fa fa-trash"></i>-->
                <!--									</button>-->
                <!--									<button class="btn btn-info btn-sm" @click="openModal(test, 'addNoteModal')">-->
                <!--										<i class="fa fa-file-text-o"></i>-->
                <!--									</button>-->
                <!--								</td>-->
              </tr>
              </tbody>
            </table>
          </div>
        </template>
        <!--				<template v-else>-->
        <!--					<div class="col-md-12">-->
        <!--						<table class="table table-striped single-outage-table">-->
        <!--							<thead>-->
        <!--								<tr class="text-center">-->
        <!--									<th ></th>-->
        <!--									<th>Test ID</th>-->
        <!--									<th>Status</th>-->
        <!--									<th>Test Name</th>-->
        <!--									<th>Server IP</th>-->
        <!--									<th>Downtime</th>-->
        <!--									<th>Primary Domain</th>-->
        <!--									<th>Outages</th>-->
        <!--&lt;!&ndash;									<th>Status Code</th>&ndash;&gt;-->
        <!--&lt;!&ndash;									<th>Uptime</th>&ndash;&gt;-->
        <!--									<th width="11%">Note</th>-->
        <!--                  <th>Node</th>-->
        <!--                  <th>Rack</th>-->
        <!--									<th>Test</th>-->
        <!--&lt;!&ndash;									<th width="12%">Action</th>&ndash;&gt;-->
        <!--								</tr>-->
        <!--							</thead>-->
        <!--							<tbody>-->
        <!--								<tr v-for="test in group.tests" :key="test.testId" :data-id="test.testId">-->
        <!--                  <td >-->
        <!--                    <div class="dropdown">-->
        <!--                      <button title="Choose Operation" class="btn btn-secondary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
        <!--                        <i class="fa fa-cog"></i>-->
        <!--                      </button>-->
        <!--                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">-->
        <!--                        <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'viewEventsModal')">View Details</a>-->
        <!--                        <a class="dropdown-item" href="javascript:void(0)" @click="findUser(group)">Login User</a>-->
        <!--                        <router-link v-if="group.uid" class="dropdown-item" :to="{ name: 'editUser', params: { docID: group.uid } }">Edit User</router-link>-->
        <!--                        <a class="dropdown-item" href="javascript:void(0)" @click="remove(test)">Delete</a>-->
        <!--                        <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'addNoteModal')">Add Notes</a>-->

        <!--                       </div>-->
        <!--                    </div>-->
        <!--                  </td>-->
        <!--&lt;!&ndash;								<td width="10%">&ndash;&gt;-->
        <!--&lt;!&ndash;									<button class="btn btn-info btn-sm mr-1" @click="openModal(test, 'viewEventsModal')"><i class="fa fa-eye"></i></button>&ndash;&gt;-->
        <!--&lt;!&ndash;									<button class="btn btn-primary btn-sm mr-1" title="Login User" @click="findUser(group)"><i class="fa fa-user"></i></button>&ndash;&gt;-->
        <!--&lt;!&ndash;									<router-link v-if="group.uid" class="btn btn-primary btn-sm"  title="Edit User" :to="{ name: 'editUser', params: { docID: group.uid } }"><i class="fa fa-pencil"></i></router-link>&ndash;&gt;-->
        <!--&lt;!&ndash;								</td>&ndash;&gt;-->
        <!--								<td class="text-center">{{ test.testId }}</td>-->
        <!--								<td class="text-center">-->
        <!--									<div @click="openModal(test, 'changeLiveStatusModal')" :class="{'sc-status': true, 'down': test.status === 'Down', 'up': test.status === 'Up', 'pause': test.status === 'Paused'}"></div>-->
        <!--								</td>-->
        <!--								<td class="text-center"><a :href="test.URL" target="_blank">{{test.URL}}</a></td>-->
        <!--								<td class="text-center">{{ test.serverIP }}</td>-->
        <!--                  <template v-if="status === 'Up'">-->
        <!--									<td class="text-center">-->
        <!--										{{timeDifferenceBetweenGivenDates(test.events[test.events.length-1].start, test.events[test.events.length-2].start)}}-->
        <!--									</td>-->
        <!--								</template>-->
        <!--								<template v-else>-->
        <!--									<td class="text-center">-->
        <!--										{{domainDateTime[test.URL]}}-->
        <!--									</td>-->
        <!--								</template>-->
        <!--								<td class="text-center">{{group.planName}}</td>-->
        <!--								<td class="text-center">{{test.downCount}}</td>-->
        <!--&lt;!&ndash;								<td class="text-center">{{test.events[test.events.length-1].statusCode}}</td>&ndash;&gt;-->
        <!--&lt;!&ndash;								<td class="text-center">{{test.upTime}}</td>&ndash;&gt;-->
        <!--								<td width="11%" class="" :title="test.note">{{(test.note && test.note !== '') ? test.note.substring(0, 20) : 'N/A'}}</td>-->
        <!--                  <td>{{ (allNodes[`${test.nodeId}`]) ? allNodes[`${test.nodeId}`].nodeName || '' : '' }}</td>-->
        <!--                  <td>{{ (allNodes[`${test.nodeId}`]) ? allNodes[`${test.nodeId}`].rack_name || '' : ''}}</td>-->
        <!--                <td width="13%">-->
        <!--									<select class="form-control" @change="updateStatusCakeValue(test, $event)">-->
        <!--										<option></option>-->
        <!--										<option :selected="(test.statusCake === undefined && (test.status === 'Up' || test.status === 'Down')) ? true : test.statusCake === 'Active'" value="Active">Active</option>-->
        <!--										<option :selected="test.statusCake === 'Moved'" value="Moved">Moved</option>-->
        <!--										<option :selected="(test.statusCake === undefined && test.status === 'Paused') ? true : test.statusCake === 'Suspended'" value="Suspended">Suspended</option>-->
        <!--										<option :selected="test.statusCake === 'Domain Expired'" value="Domain Expired">Domain Expired</option>-->
        <!--										<option :selected="test.statusCake === 'Other'" value="Other">Other</option>-->
        <!--									</select>-->
        <!--								</td>-->
        <!--&lt;!&ndash;								<td width="12%" class="text-center">&ndash;&gt;-->
        <!--&lt;!&ndash;									<button class="btn btn-warning btn-sm mr-1" :disabled="action" @click="pause(test ,1)">&ndash;&gt;-->
        <!--&lt;!&ndash;										<div class="loader mini_loader" v-if="updateItem && test.testId === updateItem.testId && action === 'update'"></div>&ndash;&gt;-->
        <!--&lt;!&ndash;										<i v-else class="fa fa-pause"></i>&ndash;&gt;-->
        <!--&lt;!&ndash;									</button>&ndash;&gt;-->
        <!--&lt;!&ndash;									<button class="btn btn-danger btn-sm mr-1" :disabled="action"  @click="remove(test)">&ndash;&gt;-->
        <!--&lt;!&ndash;										<div class="loader mini_loader" v-if="removeItem && test.testId === removeItem.testId && action === 'remove'"></div>&ndash;&gt;-->
        <!--&lt;!&ndash;										<i v-else class="fa fa-trash"></i>&ndash;&gt;-->
        <!--&lt;!&ndash;									</button>&ndash;&gt;-->
        <!--&lt;!&ndash;									<button class="btn btn-info btn-sm mr-3" @click="openModal(test, 'addNoteModal')">&ndash;&gt;-->
        <!--&lt;!&ndash;										<i class="fa fa-file-text-o"></i>&ndash;&gt;-->
        <!--&lt;!&ndash;									</button>&ndash;&gt;-->
        <!--&lt;!&ndash;								</td>&ndash;&gt;-->
        <!--							</tr>-->
        <!--							</tbody>-->
        <!--						</table>-->
        <!--					</div>-->
        <!--				</template>-->
      </div>
      <div v-if="tableType !== 'suspended'" class="row group-section mb-1 ">
        <template>
          <div class="col-md-10 mt-2">
            <label> Show
              <select id="grouped"
                      v-model="pageSize" aria-describedby="grouped"
                      class="custom-select custom-select-sm form-control form-control-sm datatable-dropdown" required>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option :value="paginatedGroups.length">All</option>
              </select> entries</label>
          </div>
          <div class="col-md-2 text-right">
            <div class="dropdown m-auto">
              <button id="dropdownMenuButton2" aria-expanded="false"
                      aria-haspopup="true" class="filter-btn btn btn-sm dropdown-toggle" data-toggle="dropdown"
                      style="width: 20px!important; padding: 0!important;" title="Filter by Tags" type="button">
                <i class="fa fa-filter fs-20"></i>
              </button>
              <div aria-labelledby="dropdownMenuButton2" class="dropdown-menu" style="min-width: 8rem;">
                <div v-for="(option, index) in filteredOptions" :key="index"
                     class="ml-10 mt-3 d-flex align-items-center">
                  <input v-model="selectedFilters" :value="option" type="checkbox" @input="checkOption($event)">
                  <span v-if="option.tag === 'all' || option.tag === 'none'" class="ml-10">
                      {{ option.text }}
                    </span>
                  <img v-else :src="option.src" alt="" class="ml-10" style="width: 30px !important;">
                </div>
                <div class="ml-10 mt-3 d-flex align-items-center">
                  <input :key="datatableId" v-model="notInWPOFilter" :value="notInWPOFilter" type="checkbox">
                  <i class="fa fa-ban ml-10 text-danger" style="font-size: 28px" title="Not In WPO"></i>
                </div>

              </div>
            </div>
          </div>
          <div class="col-md-12 mt-2">
            <table :id="`${datatableId}-ungrouped`" class="table table-striped single-outage-table table-responsive">
              <thead>
              <tr class="text-center">
                <th></th>
                <!--								<th>Test ID</th>-->
                <th>Status
                  <!--                  <i v-if="!statusSortType || statusSortType==='desc'" class="fa fa-sort-down" :class="statusSortType==='desc' ? 'text-primary': 'text-muted'" @click="clickedStatusSort()" />-->
                  <!--                  <i v-if="!statusSortType || statusSortType==='asc'"  class="fa fa-sort-up " :style="!statusSortType?'margin-left:-7px':'' "  :class="statusSortType==='asc' ? 'text-primary': 'text-muted'" @click="clickedStatusSort()" />-->

                </th>
                <th>Tags</th>
                <th>Test Name
                  <i v-if="!planSortType || planSortType==='desc'"
                     :class="planSortType==='desc' ? 'text-primary': 'text-muted'"
                     class="fa fa-sort-down" @click="clickedPlanSort()"/>
                  <i v-if="!planSortType || planSortType==='asc'"
                     :class="planSortType==='asc' ? 'text-primary': 'text-muted'"
                     :style="!planSortType?'margin-left:-7px':'' "
                     class="fa fa-sort-up " @click="clickedPlanSort()"/>
                </th>
                <th>Server IP
                  <i v-if="!ipSortType || ipSortType==='desc'"
                     :class="ipSortType==='desc' ? 'text-primary': 'text-muted'"
                     class="fa fa-sort-down" @click="clickedIpSort()"/>
                  <i v-if="!ipSortType || ipSortType==='asc'" :class="ipSortType==='asc' ? 'text-primary': 'text-muted'"
                     :style="!ipSortType?'margin-left:-7px':'' "
                     class="fa fa-sort-up " @click="clickedIpSort()"/>
                </th>
                <th>Cause</th>
                <th width="7%">Down Time
                  <i v-if="!downtimeType || downtimeType==='desc'"
                     :class="downtimeType==='desc' ? 'text-primary': 'text-muted'"
                     class="fa fa-sort-down" @click="clickedDowntimeSort()"/>
                  <i v-if="!downtimeType || downtimeType==='asc'"
                     :class="downtimeType==='asc' ? 'text-primary': 'text-muted'"
                     :style="!downtimeType?'margin-left:-7px':'' "
                     class="fa fa-sort-up " @click="clickedDowntimeSort()"/>
                </th>
                <th>Out ages
                  <i v-if="!outageSortType || outageSortType==='desc'"
                     :class="outageSortType==='desc' ? 'text-primary': 'text-muted'"
                     class="fa fa-sort-down" @click="clickedOutageSort()"/>
                  <i v-if="!outageSortType || outageSortType==='asc'"
                     :class="outageSortType==='asc' ? 'text-primary': 'text-muted'"
                     :style="!outageSortType?'margin-left:-7px':'' "
                     class="fa fa-sort-up " @click="clickedOutageSort()"/>
                </th>
                <!--								<th>Status Code</th>-->
                <!--								<th>Uptime</th>-->
                <th width="18%">Note</th>
                <th>Plan</th>
                <th>Ticket</th>
                <th>Node
                  <i v-if="!nodeSortType || nodeSortType==='desc'"
                     :class="nodeSortType==='desc' ? 'text-primary': 'text-muted'"
                     class="fa fa-sort-down" @click="clickedNodeSort()"/>
                  <i v-if="!nodeSortType || nodeSortType==='asc'"
                     :class="nodeSortType==='asc' ? 'text-primary': 'text-muted'"
                     :style="!nodeSortType?'margin-left:-7px':'' "
                     class="fa fa-sort-up " @click="clickedNodeSort()"/>
                </th>
                <th>Rack
                  <i v-if="!rackSortType || rackSortType==='desc'"
                     :class="rackSortType==='desc' ? 'text-primary': 'text-muted'"
                     class="fa fa-sort-down" @click="clickedRackSort()"/>
                  <i v-if="!rackSortType || rackSortType==='asc'"
                     :class="rackSortType==='asc' ? 'text-primary': 'text-muted'"
                     :style="!rackSortType?'margin-left:-7px':'' "
                     class="fa fa-sort-up " @click="clickedRackSort()"/>
                </th>
                <th>Location</th>
                <th>Test</th>
                <th>Acknowledge</th>
                <!--								<th width="12%">Action</th>-->
              </tr>
              </thead>
              <tbody v-for="(group, index) in getWPOGroup" :key="index">
              <tr v-if="group.tests.length > 1">
                <td>
                  <span :class="{ 'details-control shown' : group.showTests, 'details-control' : !group.showTests }"
                        @click="renderDatatable(group, 'openedGroups')"></span>
                </td>
                <td class="text-center" width="7%">
                  <template v-if="status === 'Down'">
                    <span class="badge badge-danger p-4-4" title="Down">{{ group.downCount }}</span>
                    <span class="badge badge-warning p-4-4" title="Paused">{{ group.pauseCount }}</span>
                    <span class="badge badge-default p-4-4" title="Pending">{{ group.pendingCount }}</span>
                    <span class="badge badge-success p-4-4" title="Total"> {{ group.tests.length }}</span>
                  </template>
                  <template v-else>
                    <span class="badge badge-success" title="Total Recent Outages"> {{ group.tests.length }}</span>
                    <!--                    Total Recent Outages: <b>{{group.tests.length}}</b>-->
                  </template>
                </td>
                <td></td>
                <td class="text-center">
                  <div class="d-flex align-items-center justify-content-center">
                    <b>
                      {{ group.planName === '(N/A)' ? 'Not in WPO' : group.planName }}
                    </b>
                    <div v-if="datatableId === 'currentZabbixOutages'">
                      <div v-if="!selectedPlanLoading" class="dropdown ml-5">
                        <button id="groupAction" aria-expanded="false"
                                aria-haspopup="true" class="settinds-btn btn btn-sm dropdown-toggle"
                                data-toggle="dropdown"
                                style="width: 15px!important; padding: 0!important;" title="Choose Operation"
                                type="button">
                          <i class="fa fa-cog"></i>
                        </button>
                        <div aria-labelledby="groupAction" class="dropdown-menu">
                          <a v-if="!group.pauseGroup" class="dropdown-item"
                             href="javascript:void(0)" @click="groupActionHandler({...group, index}, 'pause')">Pause
                            Group</a>
                          <a v-else class="dropdown-item" href="javascript:void(0)"
                             @click="groupActionHandler({...group, index}, 'unpause')">Unpause Group</a>
                          <a class="dropdown-item" href="javascript:void(0)"
                             @click="groupActionHandler({...group, index}, 'delete')">Delete Group</a>
                        </div>
                      </div>
                      <div v-else-if="selectedPlanLoading && selectedIndex === index" class="ml-5">
                        <i class="fa fa-spin fa-spinner"></i>
                      </div>
                    </div>
                  </div>
                </td>
                <td> <span v-if="group.planName !== '(N/A)'" class="ml-1">
                      <b>{{ group.serverIP }}</b>
                    </span></td>
                <td></td>
                <td></td>
                <td class="text-center" width="5%">{{ getTotalOutages(group) }}</td>
                <td></td>
                <td class="text-center"><span :class="getWPOPlanClass(group)"
                                              class="badge badge-pill">{{ getWPOPlan(group) || '' }}</span></td>
                <td></td>
                <td class="text-center text-uppercase" width="3%">{{
                    (allNodes[`${group.tests[0].netboxNodeId}`]) ? allNodes[`${group.tests[0].netboxNodeId}`].name || '' : ''
                  }}
                </td>
                <td class="text-center text-uppercase" width="5%">
                  {{
                    (allNodes[`${group.tests[0].netboxNodeId}`]) ? (allNodes[`${group.tests[0].netboxNodeId}`].rack ? allNodes[`${group.tests[0].netboxNodeId}`].rack.name : '') : ''
                  }}
                </td>
                <td class="datacenter text-center">{{group.datacenter}}</td>
                <td></td>
                <td class="text-center" width="2%">
                  <template v-if="group.acknowledgedByNames.length && !group.showCheckin">
                    <span v-for="(row, index) in group.acknowledgedByNames" :key="index">
                      <img :src="`https://www.gravatar.com/avatar/${getHash(row)}?s=50`" :title="row" data-html="true"
                           data-placement="top"
                           data-toggle="tooltip" style="border-radius: 50%;"
                           width="35%">
                    </span>
                  </template>
                  <button v-if="status === 'Down' && group.showCheckin && group.downCount > 1"
                          :disabled="(selectedPlanLoading && selectedPlanLoading === group.planName) || selectedIndex === index"
                          class="btn btn-primary btn-sm"
                          type="button"
                          @click="bulkAcknowledgeV2({...group, index}, user.firstName + ' ' + user.lastName)">
                    <span v-if="selectedPlanLoading && selectedPlanLoading === group.planName">
                      <div class="loader mini_loader"></div>
                    </span>
                    <span v-else>
                      Check In
                    </span>
                  </button>
                </td>
                <!--                <td class="text-center">-->
                <!--                  <template  v-if="status === 'down'">-->
                <!--                  <span title="Down" class="badge badge-danger mr-1">{{group.downCount}}</span>-->
                <!--                  <span title="Paused" class="badge badge-warning mr-1">{{group.pauseCount}}</span>-->
                <!--                  <span title="Total" class="badge badge-success"> {{group.tests.length}}</span>-->
                <!--                </template>-->
                <!--                  <template v-else>-->
                <!--                    <span title="Total Recent Outages" class="badge badge-success"> {{group.tests.length}}</span>-->
                <!--                    &lt;!&ndash;                    Total Recent Outages: <b>{{group.tests.length}}</b>&ndash;&gt;-->
                <!--                  </template>-->
                <!--                  &lt;!&ndash;                  <button v-if="group.uid"  class="btn btn-primary btn-sm mr-3 ml-3 text-right" title="Login User" @click="findUser(group)"><i class="fa fa-user"></i></button>&ndash;&gt;-->
                <!--                  &lt;!&ndash;                  <router-link v-if="group.uid"  class="btn btn-primary btn-sm text-right"  title="Edit User" :to="{ name: 'editUser', params: { docID: group.uid } }"><i class="fa fa-pencil"></i></router-link>&ndash;&gt;-->
                <!--                </td>-->
              </tr>
              <tr v-else-if="group.tests.length==1"
                  :class="{ 'down-monitor-bg' : group.tests[0].status === 'down' && checkDownTime(group.tests[0]) > 5 }">
                <td width="1%">
                  <div class="dropdown m-auto">
                    <button id="dropdownMenuButton2" aria-expanded="false"
                            aria-haspopup="true" class="settinds-btn btn btn-sm dropdown-toggle" data-toggle="dropdown"
                            style="width: 15px!important; padding: 0!important;" title="Choose Operation" type="button">
                      <i class="fa fa-cog"></i>
                    </button>
                    <div aria-labelledby="dropdownMenuButton2" class="dropdown-menu">
                      <a class="dropdown-item" href="javascript:void(0)"
                         @click="openModal(group.tests[0], 'viewEventsModal')">View Details</a>
                      <a class="dropdown-item" href="javascript:void(0)" @click="redirectToGraph(group.tests[0])">View
                        Graph</a>
                      <a class="dropdown-item" href="javascript:void(0)"
                         @click="allowedTabs.includes(datatableId) ? removeZabbixMonitor(group.tests[0], group) : remove(group.tests[0], group)">Delete</a>
                      <a class="dropdown-item" href="javascript:void(0)"
                         @click="openModal(group.tests[0], 'addNoteModal')">Add Notes</a>
                      <a class="dropdown-item" href="javascript:void(0)" @click="findUser(group)">Login User</a>
                      <a class="dropdown-item" href="javascript:void(0)" @click=" openTicketModal(group.tests[0])">Create
                        Ticket</a>
                      <router-link v-if="group.uid "
                                   :to="{ name: 'editUser', params: { docID: group.uid || group.tests[0].uid } }"
                                   class="dropdown-item">Edit
                        User
                      </router-link>
                      <a class="dropdown-item" href="javascript:void(0)"
                         @click="openModal(group.tests[0], 'showTempUrl')">Temp URL</a>
                      <a class="dropdown-item" href="javascript:void(0)" @click="openHbProfile(group.tests[0])">Hostbill
                        Profile</a>
                    </div>
                  </div>
                </td>
                <!--								<td width="3%">-->
                <!--									<button class="btn btn-info btn-sm" @click="openModal(test, 'viewEventsModal')"><i class="fa fa-eye"></i></button>-->
                <!--								</td>-->
                <!--                  <td class="text-center">{{ group.tests[0].testId }}</td>-->
                <td class="text-center" width="1%">
                  <div
                      :class="{'sc-status': true, 'down': group.tests[0].status === 'down', 'up': group.tests[0].status === 'up', 'pause': group.tests[0].status === 'paused', 'pending': group.tests[0].status === 'pending'}"
                      @click="openModal(group.tests[0], 'changeLiveStatusModal')"></div>
                </td>
                <td class="text-center" width="5%">
                  <div v-if="group.tests[0].tagCategories && group.tests[0].tagCategories.length>0"
                       :style="`min-width: ${(25 * group.tests[0].tagCategories.length)+5}px;`"
                       class="text-center">
                    <span v-for="(row, index) in group.tests[0].tagCategories" :key="index" class="cursor-pointer">
                      <img v-if="row.tag.toLowerCase() === 'cloudflare'"
                           :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                           class="" src="../../../assets/img/cloudflare.png" style="width: 20px !important;">
                      <img v-if="row.tag.toLowerCase() === 'bigscoots' && row.category.toLowerCase() === 'cfe'"
                           :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                           class="" src="../../../../src/assets/img/bigscoots_cf.png" style="width: 20px !important;">
                      <img v-if="row.tag.toLowerCase() === 'bigscoots' && row.category.toLowerCase() === 'host'"
                           :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                           class="" src="../../../../src/assets/img/bigscoots.jpg" style="width: 20px !important;">
                      <img v-if="row.tag.toLowerCase() === 'ezoic' && row.category.toLowerCase() === 'cache'"
                           :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                           class="" src="../../../../src/assets/img/ezoic_cache.png" style="width: 20px !important;">
                      <img v-if="row.tag.toLowerCase() === 'ezoic' && row.category.toLowerCase() === 'ads'"
                           :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                           class="" src="../../../../src/assets/img/ezoic_ADS.png" style="width: 20px !important;">
                      <img v-if="row.tag.toLowerCase() === 'sucuri'" :title="`${row.tag.toUpperCase()}`" alt=""
                           class="" src="../../../../src/assets/img/sucuri.png" style="width: 20px !important;">
                      <img v-if="row.tag.toLowerCase() === 'squarespace'" :title="`${row.tag.toUpperCase()}`" alt=""
                           class="" src="../../../../src/assets/img/squarespace.png" style="width: 20px !important;">
                      <img v-if="row.tag.toLowerCase() === 'nerdpress'" :title="`${row.tag.toUpperCase()}`" alt=""
                           class="" src="../../../../src/assets/img/nerdpress.png" style="width: 20px !important;">
                      <img v-if="row.tag.toLowerCase() === 'wix'" :title="`${row.tag.toUpperCase()}`" alt=""
                           class="" src="../../../../src/assets/img/wix.png" style="width: 20px !important;">
                      <img v-if="row.tag.toLowerCase() === 'shopify'" :title="`${row.tag.toUpperCase()}`" alt=""
                           class="" src="../../../../src/assets/img/shopify-tag.png" style="width: 20px !important;">
                    </span>
                  </div>
                  <span v-if="group.notInWPO">
                    <img v-if="group.tag && group.tag === 'cpanel'" alt=""
                         class="" src="../../../../src/assets/img/cpanel.png" style="width: 20px !important;">
                    <i v-else aria-hidden="true" class="fa fa-ban text-danger fs-20 make-cursor-pointer"
                       title="Not In WPO"></i>
                  </span>

                </td>
                <td class="text-center domain" width="20%">
                  <div>
                    <a :href="getEffectiveUrl(group.tests[0])" target="_blank">
                      {{ showDomainName(group.tests[0].url) }}
                      <!--                     {{group.tests[0].url.includes('https://') ? group.tests[0].url.split('https://')[1].replace('/?v={timestamp}', '') : group.tests[0].url.replace('/?v={timestamp}', '')}}-->
                    </a>
                    <a v-if="group.tests[0].status === 'down' && getScreenshotUrl(group.tests[0])"
                       :href="getScreenshotUrl(group.tests[0])" target="_blank"><img
                        :key="group.tests[0].url+'screenshot'"
                        alt=""
                        class="ml-2 w-8"
                        data-html="true"
                        data-placement="top"
                        data-toggle="tooltip"
                        src="../../../../src/assets/img/screenshot.png"
                        title="View Screenshot"></a>
                    <a v-if="getResponseUrl(group.tests[0])" :href="getResponseUrl(group.tests[0])" target="_blank"><img
                        :key="group.tests[0].url+'response'" alt="" class="ml-2 w-6" data-html="true"
                        data-placement="top" data-toggle="tooltip" src="../../../../src/assets/img/browser.png"
                        title="View Response Url"></a>
                    <span v-if="checkActiveJob(group.tests[0])" :key="index+'638active'"
                          :title="getActiveJobTitle(group.tests[0])" class="cursor-pointer" data-html="true"
                          data-placement="top" data-toggle="tooltip">⚠️</span>
                    <span v-if="checkPhpJob(group.tests[0])" :key="index+'639php'"
                          :title="getPhpJobTitle(group.tests[0])" class="cursor-pointer" data-html="true"
                          data-placement="top" data-toggle="tooltip">
                        <img height="25" src="../../../assets/img/php-job.png">
                      </span>
                    <span v-if="checkCompletedJob(group.tests[0])" :key="group.tests[0]+'completeJob'"
                          :title="getCompletedJobTitle(group.tests[0])" class="cursor-pointer" data-html="true"
                          data-placement="top" data-toggle="tooltip">⚠️<i
                        class="fa fa-check text-success"></i></span>
                  </div>
                </td>
                <td class="text-center" width="3%" @click="doCopy(group.tests[0].serverIP)">
                  {{ group.tests[0].serverIP }}
                </td>
                <template v-if="group.tests[0].incidents[group.tests[0].incidents.length - 1].cause">
                  <td v-if="group.tests[0].incidents[group.tests[0].incidents.length - 1].cause.length > causeLength"
                      width="10%">
                    <span v-if="!getProperty(group.tests[0].id)">
                      {{ group.tests[0].incidents[group.tests[0].incidents.length - 1].cause.slice(0, causeLength) }}
                      <a href="javascript:void(0)" @click="changeCauseLength(group.tests[0])">more</a>
                    </span>

                    <template v-else>
                      {{ group.tests[0].incidents[group.tests[0].incidents.length - 1].cause }}
                      <a href="javascript:void(0)" @click="changeCauseLength(group.tests[0])">less</a>
                    </template>
                  </td>

                  <td v-else width="10%">{{ group.tests[0].incidents[group.tests[0].incidents.length - 1].cause }}</td>
                </template>
                <template v-else>
                  <td width="10%">{{ group.tests[0].incidents[group.tests[0].incidents.length - 1].cause }}</td>
                </template>
                <template v-if="status === 'up'">
                  <td class="text-center" width="3%">
                    {{
                      timeDifferenceBetweenGivenDates(group.tests[0].incidents[group.tests[0].incidents.length - 1].end, group.tests[0].incidents[group.tests[0].incidents.length - 1].start)
                    }}
                    <!--                    {{group.tests[0].incidents[group.tests[0].incidents.length-1].start}}-->
                  </td>
                </template>
                <template v-else>
                  <td class="text-center" width="3%">
                    {{ domainDateTime[group.tests[0].url] }}
                  </td>
                </template>
                <td class="text-center" width="3%">{{ group.tests[0].zabbixDownCount }}</td>
                <!--								<td class="text-center">{{test.events[test.events.length-1].statusCode}}</td>-->
                <!--								<td class="text-center">{{test.upTime}}</td>-->
                <td :title="getNoteTooltip(group.tests[0])" class="cursor-pointer domain" width="18%"
                    @click="openModal(group.tests[0], 'addNoteModal')">
                  {{ (group.tests[0].note && group.tests[0].note !== '') ? group.tests[0].note : 'N/A' }}
                </td>
                <td class="text-center"><span :class="getWPOPlanClass(group)"
                                              class="badge badge-pill">{{ getWPOPlan(group) }}</span></td>
                <td class="text-center" width="5%">
                  <a class="make-cursor-pointer" data-toggle="tooltip" href="javascript:void(0)"
                     title="View Client Tickets" @click="viewClientTickets(group.tests[0])">
                    <svg class="mr-3" fill="#5B7CFB" height="12px" viewBox="0 0 640 512" width="20px"
                         xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M48 48l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L32 0C14.3 0 0 14.3 0 32L0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7l56.1 0c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4l-69.3 0zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3l-69.3 0c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6l56.1 0zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1l-80 0c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80-32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM504 48l88 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104c0-17.7-14.3-32-32-32L504 0c-13.3 0-24 10.7-24 24s10.7 24 24 24zM48 464l0-88c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 480c0 17.7 14.3 32 32 32l104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0zm456 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0c17.7 0 32-14.3 32-32l0-104c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88-88 0z"/>
                    </svg>
                  </a>
                  <template
                      v-if="group.tests[0].acknowledgedBy && (group.tests[0].acknowledgedBy === `${user.firstName} ${user.lastName}`)">
                    <i v-if="loadingOfTicket.flag && loadingOfTicket.id === group.tests[0].id"
                       class="fa fa-spin text-primary mr-2 fa-spinner"></i>
                    <i v-else class="fa fa-ticket text-primary mr-2 make-cursor-pointer" data-html="true"
                       data-placement="top" data-toggle="tooltip" title="1-Click Ticket"
                       @click="openTicketModal(group.tests[0], 'ticketIcon')"></i>
                  </template>
                  <i :key="group.tests[0].url+'editTicket123'" class="text-primary fa fa-pencil cursor-pointer"
                     data-html="true"
                     data-placement="top" data-toggle="tooltip" title="Edit ticket"
                     @click="openModal(group.tests[0], 'addTicketModal')"></i>
                  <a v-if="group.tests[0].ticket_url" :href="group.tests[0].ticket_url" target="_blank">
                    <i :class="group.tests[0].ticket_url ? 'text-primary' : 'text-muted'" class=" fa fa-eye ml-2"
                       title="View Ticket"></i>
                  </a>
                </td>
                <td class="text-center text-uppercase" width="3%">{{
                    (allNodes[`${group.tests[0].netboxNodeId}`]) ? allNodes[`${group.tests[0].netboxNodeId}`].name || '' : ''
                  }}
                </td>
                <td class="text-center text-uppercase" width="2%">
                  {{
                    (allNodes[`${group.tests[0].netboxNodeId}`]) ? (allNodes[`${group.tests[0].netboxNodeId}`].rack ? allNodes[`${group.tests[0].netboxNodeId}`].rack.name : '') : ''
                  }}
                </td>
                <td class="datacenter">{{group.tests[0].datacenter}}</td>
                <td width="10%">
                  <select :key="group.tests[0].id" class="form-control"
                          style="height: 31px; min-width: 70px; max-width: 190px"
                          @change="updateStatusCakeValue(group.tests[0], $event)">
                    <option v-for="(row, index) in statusList" :key="index"
                            :selected="checkStatusCake(group.tests[0], row.status)" :value="row.status">
                      {{ row.status }}
                    </option>
                    <!--                    <option :selected="(group.tests[0].statusCake === undefined && (group.tests[0].status === 'up' || group.tests[0].status === 'down')) ? true : group.tests[0].statusCake === 'Active'" value="Active">Active</option>-->
                    <!--                    <option :selected="group.tests[0].statusCake === 'Moved'" value="Moved">Moved</option>-->
                    <!--                    <option :selected="(group.tests[0].statusCake === undefined && group.tests[0].status === 'paused') ? true : group.tests[0].statusCake === 'Suspended'" value="Suspended">Suspended</option>-->
                    <!--                    <option :selected="group.tests[0].statusCake === 'Domain Expired'" value="Domain Expired">Domain Expired</option>-->
                    <!--                    <option :selected="group.tests[0].statusCake === 'Other'" value="Other">Other</option>-->
                  </select>
                </td>
                <td class="text-center" width="2%">
                  <template v-if="group.tests[0].acknowledgedBy">
                    <span>
<!--												{{ group.tests[0].acknowledgedBy }}-->
                      <img :src="`https://www.gravatar.com/avatar/${getHash(group.tests[0].acknowledgedBy)}?s=50`"
                           :title="group.tests[0].acknowledgedBy" data-html="true" data-placement="top"
                           data-toggle="tooltip" style="border-radius: 50%;"
                           width="35%">
											</span>
                  </template>
                  <button v-else-if="group.tests[0].status === 'down'"
                          :disabled="(selectedMonitorLoading && selectedMonitorLoading === group.tests[0].id) || selectedIndex === index"
                          class="btn btn-primary btn-sm"
                          type="button"
                          @click="bulkAcknowledgeV2({...group, index}, user.firstName + ' ' + user.lastName)">
                    <span v-if="selectedMonitorLoading && selectedMonitorLoading === group.tests[0].id">
                      <div class="loader mini_loader"></div>
                    </span>
                    <span v-else>
                      Check In
                    </span>
                  </button>
                </td>
              </tr>
              <tr v-for="(test, testindex) in (group.tests)"
                  v-show="group.tests.length > 1 && group.showTests" :key="test.id"
                  :class="test.status === 'down' && checkDownTime(test) > 5 ? 'down-monitor-bg' : 'bg-light'"
                  :data-id="test.id">
                <td width="1%">
                  <div class="dropdown m-auto">
                    <button id="dropdownMenuButton1" aria-expanded="false"
                            aria-haspopup="true" class="btn settinds-btn btn-sm dropdown-toggle" data-toggle="dropdown"
                            style="width: 15px!important; padding: 0!important;" title="Choose Operation" type="button">
                      <i class="fa fa-cog"></i>
                    </button>
                    <div aria-labelledby="dropdownMenuButton1" class="dropdown-menu">
                      <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'viewEventsModal')">View
                        Details</a>
                      <a class="dropdown-item" href="javascript:void(0)" @click="redirectToGraph(test)">View Graph</a>
                      <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'showTempUrl')">Temp
                        URL</a>
                      <a class="dropdown-item" href="javascript:void(0)"
                         @click="allowedTabs.includes(datatableId) ? removeZabbixMonitor(test, group) : remove(test, group)">Delete</a>
                      <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'addNoteModal')">Add
                        Notes</a>
                      <a v-if="group.uid" class="dropdown-item" href="javascript:void(0)" @click=" findUser(group)">Login
                        User</a>
                      <a v-if="group.uid" class="dropdown-item" href="javascript:void(0)"
                         @click="openTicketModal(test)">Create Ticket</a>
                      <a class="dropdown-item" href="javascript:void(0)" @click="openHbProfile(test)">Hostbill
                        Profile</a>

                      <router-link v-if="group.uid" :to="{ name: 'editUser', params: { docID: group.uid || test.uid } }"
                                   class="dropdown-item">Edit User
                      </router-link>

                    </div>
                  </div>
                </td>

                <td class="text-center" width="1%">
                  <div
                      :class="{'sc-status': true, 'down': test.status === 'down', 'up': test.status === 'up', 'pause': test.status === 'paused', 'pending': test.status === 'pending'}"
                      @click="openModal(test, 'changeLiveStatusModal')"></div>
                </td>
                <td class="text-center" width="5%">
                  <div v-if="test.tagCategories && test.tagCategories.length>0"
                       :style="`min-width: ${(25 * test.tagCategories.length)+5}px;`"
                       class="text-center">
                    <span v-for="(row, index) in test.tagCategories" :key="index" class="cursor-pointer">
                      <img v-if="row.tag.toLowerCase() === 'cloudflare'"
                           :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                           class="" src="../../../assets/img/cloudflare.png" style="width: 20px !important;">
                      <img v-if="row.tag.toLowerCase() === 'bigscoots' && row.category.toLowerCase() === 'cfe'"
                           :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                           class="" src="../../../../src/assets/img/bigscoots_cf.png" style="width: 20px !important;">
                      <img v-if="row.tag.toLowerCase() === 'bigscoots' && row.category.toLowerCase() === 'host'"
                           :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                           class="" src="../../../../src/assets/img/bigscoots.jpg" style="width: 20px !important;">
                      <img v-if="row.tag.toLowerCase() === 'ezoic' && row.category.toLowerCase() === 'cache'"
                           :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                           class="" src="../../../../src/assets/img/ezoic_cache.png" style="width: 20px!important;">
                      <img v-if="row.tag.toLowerCase() === 'ezoic' && row.category.toLowerCase() === 'ads'"
                           :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                           class="" src="../../../../src/assets/img/ezoic_ADS.png" style="width: 20px!important;">
                      <img v-if="row.tag.toLowerCase() === 'sucuri'" :title="`${row.tag.toUpperCase()}`" alt=""
                           class="" src="../../../../src/assets/img/sucuri.png" style="width: 20px !important;">
                      <img v-if="row.tag.toLowerCase() === 'squarespace'" :title="`${row.tag.toUpperCase()}`" alt=""
                           class="" src="../../../../src/assets/img/squarespace.png" style="width: 20px !important;">
                      <img v-if="row.tag.toLowerCase() === 'nerdpress'" :title="`${row.tag.toUpperCase()}`" alt=""
                           class="" src="../../../../src/assets/img/nerdpress.png" style="width: 20px !important;">
                      <img v-if="row.tag.toLowerCase() === 'wix'" :title="`${row.tag.toUpperCase()}`" alt=""
                           class="" src="../../../../src/assets/img/wix.png" style="width: 20px !important;">
                      <img v-if="row.tag.toLowerCase() === 'shopify'" :title="`${row.tag.toUpperCase()}`" alt=""
                           class="" src="../../../../src/assets/img/shopify-tag.png" style="width: 20px !important;">
                  </span>
                  </div>
                </td>
                <td class="text-center domain" width="20%">
                  <div>
                    <a :href="getEffectiveUrl(test)" target="_blank">
                      {{ showDomainName(test.url) }}
                      <!--                      {{ showDomainName(test.url) }}-->
                      <!--                      {{// test.url.includes('https://') ? test.url.split('https://')[1].replace('/?v={timestamp}', '') : test.url.replace('/?v={timestamp}', '')}}-->
                    </a>
                    <a v-if="test.status === 'down' && getScreenshotUrl(test)" :href="getScreenshotUrl(test)"
                       target="_blank"><img :key="test.url+'screenshot1'" alt="" class="ml-2 w-8"
                                            data-html="true" data-placement="top" data-toggle="tooltip"
                                            src="../../../../src/assets/img/screenshot.png" title="View Screenshot"></a>
                    <a v-if="getResponseUrl(test)" :href="getResponseUrl(test)" target="_blank"><img
                        :key="test.url+'response1'" alt="" class="ml-2 w-6" data-html="true"
                        data-placement="top" data-toggle="tooltip" src="../../../../src/assets/img/browser.png"
                        title="View Response Url"></a>
                    <span v-if="checkActiveJob(test)" :key="testindex+'active'" :title="getActiveJobTitle(test)"
                          class="cursor-pointer" data-html="true" data-placement="top"
                          data-toggle="tooltip">⚠️</span>
                    <span v-if="checkPhpJob(test)" :key="testindex+'php'" :title="getPhpJobTitle(test)"
                          class="cursor-pointer" data-html="true" data-placement="top" data-toggle="tooltip">
                        <img height="25" src="../../../assets/img/php-job.png">
                      </span>
                    <span v-if="checkCompletedJob(test)" :key="test+'completeJob'" :title="getCompletedJobTitle(test)"
                          class="cursor-pointer" data-html="true" data-placement="top" data-toggle="tooltip">⚠️<i
                        class="fa fa-check text-success"></i></span>
                  </div>
                </td>
                <td class="text-center" width="3%" @click="doCopy(test.serverIP)">{{ test.serverIP }}</td>
                <template v-if="test.incidents[test.incidents.length - 1].cause">
                  <td v-if="test.incidents[test.incidents.length - 1].cause.length > causeLength" width="10%">
                  <span v-if="!getProperty(test.id)">
                  {{ test.incidents[test.incidents.length - 1].cause.slice(0, causeLength) }}
                  <a href="javascript:void(0)" @click="changeCauseLength(test)"> more</a>
                  </span>
                    <template v-else>
                      {{ test.incidents[test.incidents.length - 1].cause }}
                      <a href="javascript:void(0)" @click="changeCauseLength(test)"> less</a>
                    </template>

                  </td>

                  <td v-else width="10%">{{ test.incidents[test.incidents.length - 1].cause }}</td>
                </template>
                <template v-else>
                  <td width="10%">{{ test.incidents[test.incidents.length - 1].cause }}</td>
                </template>


                <template v-if="status === 'up'">
                  <td class="text-center" width="3%">
                    {{
                      timeDifferenceBetweenGivenDates(test.incidents[test.incidents.length - 1].start, test.incidents[test.incidents.length - 2].start)
                    }}
                  </td>
                </template>
                <template v-else>
                  <td class="text-center" width="6%">
                    {{ domainDateTime[test.url] }}
                  </td>
                </template>
                <td class="text-center" width="3%">{{ test.zabbixDownCount }}</td>
                <!--								<td class="text-center">{{test.events[test.events.length-1].statusCode}}</td>-->
                <!--								<td class="text-center">{{test.upTime}}</td>-->
                <td :title="getNoteTooltip(test)" class="cursor-pointer domain" width="18%"
                    @click="openModal(test, 'addNoteModal')">{{ (test.note && test.note !== '') ? test.note : 'N/A' }}
                </td>
                <td></td>
                <td class="text-center" width="4%">
                  <a class="make-cursor-pointer" data-toggle="tooltip" title="View Client Tickets"
                     @click="viewClientTickets(test)">
                    <svg class="mr-3" fill="#5B7CFB" height="12px" viewBox="0 0 640 512" width="20px"
                         xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M48 48l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L32 0C14.3 0 0 14.3 0 32L0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7l56.1 0c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4l-69.3 0zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3l-69.3 0c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6l56.1 0zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1l-80 0c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80-32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM504 48l88 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104c0-17.7-14.3-32-32-32L504 0c-13.3 0-24 10.7-24 24s10.7 24 24 24zM48 464l0-88c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 480c0 17.7 14.3 32 32 32l104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0zm456 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0c17.7 0 32-14.3 32-32l0-104c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88-88 0z"/>
                    </svg>
                  </a>
                  <template
                      v-if="test.acknowledgedBy && (test.acknowledgedBy === `${user.firstName} ${user.lastName}`)">
                    <i v-if="loadingOfTicket.flag && loadingOfTicket.id === test.id"
                       class="fa fa-spin mr-2 text-primary fa-spinner"></i>
                    <i v-else class="fa fa-ticket text-primary mr-2 make-cursor-pointer" data-html="true"
                       data-placement="top"
                       data-toggle="tooltip" title="1-Click Ticket"
                       @click="openTicketModal(test, 'ticketIcon')"></i>
                  </template>
                  <i :key="test.url+'editTicket321'" class="text-primary fa fa-pencil cursor-pointer" data-html="true"
                     data-placement="top" data-toggle="tooltip" title="Edit ticket"
                     @click="openModal(test, 'addTicketModal')"></i>
                  <a v-if="test.ticket_url" :href="test.ticket_url" target="_blank">
                    <i :class="test.ticket_url ? 'text-primary' : 'text-muted'" class=" fa fa-eye ml-2"
                       title="View Ticket"></i>
                  </a>
                </td>
                <td class="text-center text-uppercase" width="3%">
                  {{ (allNodes[`${test.netboxNodeId}`]) ? allNodes[`${test.netboxNodeId}`].name || '' : '' }}
                </td>
                <td class="text-center text-uppercase" width="2%">
                  {{
                    (allNodes[`${test.netboxNodeId}`]) ? (allNodes[`${test.netboxNodeId}`].rack ? allNodes[`${test.netboxNodeId}`].rack.name : '') : ''
                  }}
                </td>
                <td class="datacenter">{{test.datacenter}}</td>
                <td width="10%">
                  <select :key="test.id" class="form-control" style="height: 31px; min-width: 70px; max-width: 190px"
                          @change="updateStatusCakeValue(test, $event)">
                    <!--                    <option></option>-->
                    <option v-for="(row, index) in statusList" :key="index"
                            :selected="checkStatusCake(test, row.status)" :value="row.status">
                      {{ row.status }}
                    </option>
                    <!--                    <option :selected="(test.statusCake === undefined && (test.status === 'up' || test.status === 'down')) ? true : test.statusCake === 'Active'" value="Active">Active</option>-->
                    <!--                    <option :selected="test.statusCake === 'Moved'" value="Moved">Moved</option>-->
                    <!--                    <option :selected="(test.statusCake === undefined && test.status === 'paused') ? true : test.statusCake === 'Suspended'" value="Suspended">Suspended</option>-->
                    <!--                    <option :selected="test.statusCake === 'Domain Expired'" value="Domain Expired">Domain Expired</option>-->
                    <!--                    <option :selected="test.statusCake === 'Other'" value="Other">Other</option>-->
                  </select>
                </td>
                <td class="text-center" width="2%">
                  <template>
                    <span v-if="test.acknowledgedBy">
                      <img :src="`https://www.gravatar.com/avatar/${getHash(test.acknowledgedBy)}?s=50`"
                           :title="test.acknowledgedBy" data-html="true" data-placement="top"
                           data-toggle="tooltip" style="border-radius: 50%;"
                           width="35%">
                      <!--												{{// test.acknowledgedBy}}-->
                    </span>
                    <template v-else-if="test.status === 'down'">
                      <button
                          v-if="group.downCount === 1"
                          :disabled="selectedMonitorLoading && selectedMonitorLoading === test.id"
                          class="btn btn-primary btn-sm" type="button"
                          @click="bulkAcknowledgeV2({...group, tests: [test], index}, user.firstName + ' ' + user.lastName, )">
                        <span v-if="selectedMonitorLoading && selectedMonitorLoading === test.id">
                          <div class="loader mini_loader"></div>
                        </span>
                        <span v-else>
                          Check In
                        </span>
                      </button>
                      <!--                      <button v-if="group.downCount === 1" type="button" class="btn btn-primary btn-sm">-->
                      <!--                        Check in-->
                      <!--                      </button>-->
                      <span v-else class="badge badge-pill badge-danger">
												Pending
                      </span>

                    </template>

                  </template>
                  <!--                  <template v-if="group.tests[0].acknowledgedBy">-->
                  <!--                    <span class="badge badge-pill badge-success">-->
                  <!--												{{ group.tests[0].acknowledgedBy }}-->
                  <!--											</span>-->
                  <!--                  </template>-->
                  <!--                  <button @click="acknowledge(group.tests[0])" v-else-if="group.tests[0].status === 'down'" :disabled="selectedMonitorLoading && selectedMonitorLoading === group.tests[0].id" type="button" class="btn btn-primary btn-sm">-->
                  <!--                    <span v-if="selectedMonitorLoading && selectedMonitorLoading === group.tests[0].id">-->
                  <!--                      <div class="loader mini_loader"></div>-->
                  <!--                    </span>-->
                  <!--                    <span v-else>-->
                  <!--                      Check In-->
                  <!--                    </span>-->
                  <!--                  </button>-->
                </td>
              </tr>
              </tbody>

            </table>
          </div>
        </template>

      </div>
      <div v-if="getWPOGroup.length > 0 && tableType !== 'suspended'" class="row mt-2">
        <div class="col-md-12 text-center">
                    <span class="lh-3 pull-left">
                        Page {{ this.pageNumber + 1 }} of {{ pageCount }}
                    </span>
          <section class="dataTables_paginate paging_full_numbers">
            <paginate
                :clickHandler="goToPage"
                :nextText="'Next'"
                :pageCount="pageCount"
                :prevText="'Prev'"
                containerClass="pagination"
                next-class="page-item"
                next-link-class="page-link"
                page-class="page-item"
                page-link-class="page-link"
                prev-class="page-item"
                prev-link-class="page-link">
            </paginate>
          </section>
        </div>
      </div>
      <div v-if="getWPOGroup.length === 0 && tableType !== 'suspended'" class="customer-list-info">
        <div class="card-text text-center text-danger mb-3 font-weight-bold">
          No {{ (status === 'Up') ? 'Recent' : 'Current' }} Outages Exists!
        </div>
      </div>
    </section>


  </div>
</template>

<script>
import _ from "lodash";
import dateMixin from '../../../mixins/dateMixin'
import loginAsMixin from "../../../mixins/loginAsMixin";
import statisticsMixin from "../../../mixins/statisticsMixin";
import AdminLogs from "@/mixins/adminLogs";
import moment from 'moment-timezone';
import swal from "sweetalert2";
import {db} from "@/firebase/init";
import Paginate from 'vuejs-paginate'
import md5 from "crypto-js/md5";
import tempDomainModal from "@/components/Admin/Tasks/showTempDomainModal.vue";


export default {
  name: "BetterUptimeTable",
  props: ["datatableId", "status", 'searchQuery', 'presetMacros', 'tableType', 'ticketLoading'],
  mixins: [dateMixin, loginAsMixin, statisticsMixin, AdminLogs],
  components: {
    tempDomainModal, Paginate,
    affectedNodesAndRacks: () =>
        import(/* webpackChunkName: "userList" */ "../../../components/Admin/Dashboard/affectedNodesAndRacks"),
  },

  data() {
    return {
      loadingOfTicket: {flag: false, id: null},
      selectedFilters: [{tag: 'all', text: 'All Tags'},
        {tag: 'cloudflare', category: 'service', src: require('@/assets/img/cloudflare.png')},
        {tag: 'ezoic', category: 'cache', src: require('@/assets/img/ezoic_cache.png')},
        {tag: 'sucuri', category: 'service', src: require('@/assets/img/sucuri.png')},
        {tag: 'bigscoots', category: 'cfe', src: require('@/assets/img/bigscoots_cf.png')},
        {tag: 'squarespace', category: 'host', src: require('@/assets/img/squarespace.png')},
        {tag: 'nerdpress', category: 'cfe', src: require('@/assets/img/nerdpress.png')},
        {tag: 'ezoic', category: 'ads', src: require('@/assets/img/ezoic_ADS.png')},
        {tag: 'wix', category: 'host', src: require('@/assets/img/wix.png')},
        {tag: 'bigscoots', category: 'host', src: require('@/assets/img/bigscoots.jpg')},
        {tag: 'shopify', category: 'host', src: require('@/assets/img/shopify-tag.png')},
        {tag: 'none', text: 'No Tags'}
      ],
      allFilterSelected: false,
      notInWPOFilter: true,
      filteredOptions: [
        {tag: 'all', text: 'All Tags'},
        {tag: 'cloudflare', category: 'service', src: require('@/assets/img/cloudflare.png')},
        {tag: 'ezoic', category: 'cache', src: require('@/assets/img/ezoic_cache.png')},
        {tag: 'sucuri', category: 'service', src: require('@/assets/img/sucuri.png')},
        {tag: 'bigscoots', category: 'cfe', src: require('@/assets/img/bigscoots_cf.png')},
        {tag: 'squarespace', category: 'host', src: require('@/assets/img/squarespace.png')},
        {tag: 'nerdpress', category: 'cfe', src: require('@/assets/img/nerdpress.png')},
        {tag: 'ezoic', category: 'ads', src: require('@/assets/img/ezoic_ADS.png')},
        {tag: 'wix', category: 'host', src: require('@/assets/img/wix.png')},
        {tag: 'bigscoots', category: 'host', src: require('@/assets/img/bigscoots.jpg')},
        {tag: 'shopify', category: 'host', src: require('@/assets/img/shopify-tag.png')},
        {tag: 'none', text: 'No Tags'},
      ],
      tracker: {},
      affectedNodes: [],
      affectedRacks: [],
      openedGroups: [],
      loading: false,
      tests: [],
      testGroups: [],
      domainDateTime: {},
      totalDownTests: 0,
      totalDownServices: 0,
      totalPausedTests: 0,
      totalPendingTests: 0,
      totalSuspendedTests: 0,
      allNodes: {},
      planSortType: null,
      ipSortType: null,
      outageSortType: null,
      nodeSortType: null,
      rackSortType: null,
      pageNumber: 0,
      updateItem: null,
      action: null,
      pageSize: 10,
      removeItem: null,
      statusSortType: null,
      downtimeType: null,
      statusList: [],
      selectedMonitorLoading: null,
      selectedPlanLoading: null,
      selectedIndex: -1,
      causeLength: 33,
      activeJobsDomainList: [],
      activeMigrationList: [],
      completedJobsDomainList: [],
      pendingJobListener: null,
      completeJobListener: null,
      migrationListener: null,
      allMembers: [],
      timeInterval: null,
      allowedTabs: ['suspendedOutages', 'currentZabbixOutages', 'recentOutages']
    }
  },
  mounted() {
    // const rf = await db.collection('zabbixMonitors').where('serverIP', '==', '38.65.227.56').get()
    // for(const r of rf.docs) {
    //   console.log('working on ', r.id)
    //   await db.collection('zabbixMonitors').doc(r.id).delete()
    // }
    this.pendingJobs();
    this.activeMigrations();
    this.completedJobs();
    this.getStatusList()
    this.getAllNodes();
    this.getAdmins()
    // $(function () {
    //   $('[data-toggle="tooltip"]').tooltip()
    // })
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    pageCount() {
      let filteredGroups = this.paginatedGroups.filter(el => el.planName !== '(N/A)' && el.planName !== 'Suspended')
      let l = filteredGroups.length, s = this.pageSize;
      return Math.ceil(l / s);
    },
    getNonWPOGroup() {
      return this.paginatedGroups.filter(el => el.planName === '(N/A)')
    },
    getSuspendedGroup() {
      return this.paginatedGroups.filter(el => {
        if (el.planName === 'Suspended') {
          el.showTests = true;
          return true
        }
      })
    },
    getWPOGroup() {
      console.log('a', this.paginatedGroups)
      // el.planName!=='(N/A)' &&
      const array = this.paginatedGroups.filter(el => el.planName !== 'Suspended')
      if (this.planSortType === 'asc') {
        console.log('in type')
        array.sort((a, b) => {
          if (a.planName.toLowerCase() > b.planName.toLowerCase()) {
            return 1
          }
          if (a.planName.toLowerCase() < b.planName.toLowerCase()) {
            return -1
          }
          return 0
        });
      } else if (this.planSortType === 'desc') {
        array.sort(function (a, b) {
          if (a.planName.toLowerCase() < b.planName.toLowerCase()) {
            return 1
          }
          if (a.planName.toLowerCase() > b.planName.toLowerCase()) {
            return -1
          }
          return 0
        });
      }
      if (this.nodeSortType === 'asc') {
        console.log('in node sort')
        array.sort((a, b) => {
          if (a.nodeName.toLowerCase() > b.nodeName.toLowerCase()) {
            return 1
          }
          if (a.nodeName.toLowerCase() < b.nodeName.toLowerCase()) {
            return -1
          }
          return 0
        });
      } else if (this.nodeSortType === 'desc') {
        array.sort(function (a, b) {
          if (a.nodeName.toLowerCase() < b.nodeName.toLowerCase()) {
            return 1
          }
          if (a.nodeName.toLowerCase() > b.nodeName.toLowerCase()) {
            return -1
          }
          return 0
        });
      }
      if (this.rackSortType === 'asc') {
        console.log('in rack sort')
        array.sort((a, b) => {
          if (a.rackName.toLowerCase() > b.rackName.toLowerCase()) {
            return 1
          }
          if (a.rackName.toLowerCase() < b.rackName.toLowerCase()) {
            return -1
          }
          return 0
        });
      } else if (this.rackSortType === 'desc') {
        array.sort(function (a, b) {
          if (a.rackName.toLowerCase() < b.rackName.toLowerCase()) {
            return 1
          }
          if (a.rackName.toLowerCase() > b.rackName.toLowerCase()) {
            return -1
          }
          return 0
        });
      }
      if (this.ipSortType === 'asc') {
        array.sort((a, b) => {
          if (a.serverIP > b.serverIP) {
            return 1
          }
          if (a.serverIP < b.serverIP) {
            return -1
          }
          return 0
        });
      } else if (this.ipSortType === 'desc') {
        array.sort(function (a, b) {
          if (a.serverIP < b.serverIP) {
            return 1
          }
          if (a.serverIP > b.serverIP) {
            return -1
          }
          return 0
        });
      }
      if (this.outageSortType === 'asc') {
        array.sort((a, b) => {
          if (a.downCounts > b.downCounts) {
            return 1
          }
          if (a.downCounts < b.downCounts) {
            return -1
          }
          return 0
        });
      } else if (this.outageSortType === 'desc') {
        array.sort(function (a, b) {
          if (a.downCounts < b.downCounts) {
            return 1
          }
          if (a.downCounts > b.downCounts) {
            return -1
          }
          return 0
        });
      }
      if (this.statusSortType === 'asc') {
        array.sort((a, b) => {
          if (a.status > b.status) {
            return 1
          }
          if (a.status < b.status) {
            return -1
          }
          return 0
        });
      } else if (this.statusSortType === 'desc') {
        array.sort(function (a, b) {
          if (a.status < b.status) {
            return 1
          }
          if (a.status > b.status) {
            return -1
          }
          return 0
        });
      }
      if (this.downtimeType === 'asc') {
        array.sort((a, b) => {
          return a.tests[0].incidents[a.tests[0].incidents.length - 1].start.localeCompare(b.tests[0].incidents[b.tests[0].incidents.length - 1].start);
        });
      } else if (this.downtimeType === 'desc') {
        array.sort((a, b) => {
          return b.tests[0].incidents[b.tests[0].incidents.length - 1].start.localeCompare(a.tests[0].incidents[a.tests[0].incidents.length - 1].start);
        });
      }

      if (!this.planSortType && !this.statusSortType && !this.ipSortType && !this.rackSortType && !this.nodeSortType && !this.outageSortType) {
        if (this.datatableId !== 'recentOutages') {
          array.sort((a, b) => {
            const hasDownA = a.tests.some(test => test.status === "down");
            const hasDownB = b.tests.some(test => test.status === "down");
            const totalDowntimeA = a.tests.reduce((sum, record) => sum + this.timeToSeconds(record.downTimeCalculated), 0);
            const totalDowntimeB = b.tests.reduce((sum, record) => sum + this.timeToSeconds(record.downTimeCalculated), 0);
            if (hasDownA !== hasDownB) return hasDownB - hasDownA;
            if (totalDowntimeA === 0 && totalDowntimeB !== 0) return 1;
            if (totalDowntimeB === 0 && totalDowntimeA !== 0) return -1;
            return totalDowntimeA - totalDowntimeB; // Ascending order
          });
        } else {
          array.sort(function (a, b) {
            // ASC  -> a.length - b.length
            // DESC -> b.length - a.length
            const getLatestDate = (obj) => {
              const timestamps = obj.tests
                  .map(test => {
                    const endDate = test.incidents[test.incidents.length - 1].end || null;
                    if (!endDate) return null;
                    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(endDate)) {
                      return null;
                    }
                    return moment.tz(endDate, "America/Chicago") // Parse as CT
                        .tz("America/New_York")
                        .valueOf();
                  })
                  .filter(time => time !== null); // Remove null values before taking max

              return timestamps.length ? Math.max(...timestamps) : null;
            };
            const dateA = getLatestDate(a);
            const dateB = getLatestDate(b);

            if (dateA === null) return 1;
            if (dateB === null) return -1;
            return dateB - dateA;
          });
        }
      }
      console.log('final array', array)
      const start = this.pageNumber * this.pageSize, end = start + this.pageSize;
      return array.slice(start, end);
    },
    paginatedGroups() {
      let filteredGroups = this.testGroups;
      if (this.searchQuery) {
        filteredGroups = filteredGroups.filter(g => {
          try {
            if (g.planName && typeof g.planName === "string" && (g.planName.toLowerCase().includes(this.searchQuery) || g.serverIP.includes(this.searchQuery))) {
              return true;
            }
            let isTestInclude = false;
            g.tests.map(t => {
              const lastIncident = t.incidents[t.incidents.length - 1]
              if (t.url.toLowerCase().includes(this.searchQuery) || t.serverIP.includes(this.searchQuery) || (this.allNodes[`${t.netboxNodeId}`] && this.allNodes[`${t.netboxNodeId}`].rack && this.allNodes[`${t.netboxNodeId}`].rack.name && this.allNodes[`${t.netboxNodeId}`].rack.name.toLowerCase().includes(this.searchQuery)) || t.wpoPlan.toLowerCase().includes(this.searchQuery) || (this.allNodes[`${t.netboxNodeId}`] && this.allNodes[`${t.netboxNodeId}`].name && this.allNodes[`${t.netboxNodeId}`].name.toLowerCase().includes(this.searchQuery)) || lastIncident.cause.toLowerCase().includes(this.searchQuery.toLowerCase())) {
                isTestInclude = true;
              }
            });
            return isTestInclude;
          } catch (e) {
            console.log(e.toString(), 'This here', g.planName)
          }
        })
      } else if (this.selectedFilters.length || this.notInWPOFilter || (this.selectedFilters.length && this.notInWPOFilter)) {
        filteredGroups = filteredGroups.filter(g => {
          let isTestInclude = false
          if (this.notInWPOFilter && g.notInWPO) {
            isTestInclude = true;
          } else {
            g.tests.map(el => {
              // find if all is selected
              const isAllSelected = this.selectedFilters.find(el => el.tag === 'all');
              // find if none is selected
              const isNoneSelected = this.selectedFilters.find(el => el.tag === 'none' && !g.notInWPO);
              if (isAllSelected) {
                // find if tag categories exist
                isTestInclude = el.tagCategories && el.tagCategories.length
              }
              if (isNoneSelected) {
                isTestInclude = !el.tagCategories || el.tagCategories && !el.tagCategories.length
              }
              if (this.selectedFilters && this.selectedFilters.length) {
                const result = (el.tagCategories && el.tagCategories.length ? el.tagCategories.every(t => {
                  return this.selectedFilters.find(tag => t.tag.toLowerCase() === tag.tag && t.category.toLowerCase() === tag.category)
                }) : false) || false
                if (result) {
                  isTestInclude = true
                }
                // console.log('result', result)
                // this.selectedFilters.map(tag => {
                //   const obj = el.tagCategories && el.tagCategories.find(t => t.tag.toLowerCase() === tag.tag && t.category.toLowerCase() === tag.category);
                //   if (obj) {
                //     isTestInclude = true
                //   }
                // })
              }
            })
          }
          return isTestInclude;
        })
      }
      console.log('groups', filteredGroups)
      return filteredGroups
    },
  },
  watch: {
    paginatedGroups() {
      // Justin asked not to change the pagesize
      // this.pageNumber = 0;
      // this.pageSize= 10
    },
    getWPOGroup() {
      console.log(`changed`)
      $('[data-toggle="tooltip"]').tooltip('dispose');
      $(function () {
        $('[data-toggle="tooltip"]').tooltip()
      })
    },
    ticketLoading(val) {
      console.log(`im ticket loading ${val.toString()}`);
      this.loadingOfTicket = val;
    }
  },
  created() {
    if (this.status !== 'Up') {
      this.timeInterval = setInterval(() => this.startClockTicking(), 1000);
    }
  },
  methods: {
    redirectToGraph(test) {
      this.$router.push({name: 'graph', params: {id: test.id}})
    },
    timeToSeconds(time) {
      console.log('timeToSeconds', time);
      if (time === "00" || time === "00:00:00" || !time) return 0; // Handle single "00" case
      const parts = time.split(":").map(Number);

      if (parts.length === 1) return parts[0]; // If it's just seconds
      if (parts.length === 2) return parts[0] * 60 + parts[1]; // If it's mm:ss
      return parts[0] * 3600 + parts[1] * 60 + parts[2]; // If it's hh:mm:ss
    },
    async groupActionHandler(group, type) {
      try {
        this.selectedIndex = group.index;
        this.selectedPlanLoading = group.planName
        const ref = await db.collection('domains').where('ip', '==', group.serverIP).limit(1).get();
        let hbHostname = ''
        if (ref.size) {
          hbHostname = ref.docs[0].data().hbHostname;
        }
        if (type === 'pause') {
          if (group.tests.length) {
            const resp = await this.$http.post("zabbix/monitor", {
              grant_type: "token",
              "action": "pause_group",
              "hostname": hbHostname
            });
            console.log('response received', resp.data)
            if (resp.data.success) {
              for (const row of group.tests) {
                await db.collection('zabbixMonitors').doc(row.id).update({
                  pauseGroup: true,
                  status: 'paused',
                  statusCake: 'Other'
                })
              }
              this.showToast({
                duration: 8000,
                message: `You have successfully ${type}d the ${group.planName}.`
              }, true, 'success')
            }
          }
        } else if (type === 'unpause') {
          if (group.tests.length) {
            const resp = await this.$http.post("zabbix/monitor", {
              grant_type: "token",
              "action": "unpause_group",
              "hostname": hbHostname
            });
            console.log('response received', resp.data)
            if (resp.data.success) {
              for (const row of group.tests) {
                await db.collection('zabbixMonitors').doc(row.id).update({
                  pauseGroup: false,
                  status: row.incidents[row.incidents.length - 1].status,
                  statusCake: 'Active'
                })
              }
              this.showToast({
                duration: 8000,
                message: `You have successfully ${type}d the ${group.planName}.`
              }, true, 'success')
            }
          }
        } else if (type === 'delete') {
          if (group.tests.length) {
            swal({
              title: "Are you sure?",
              text: `Are you sure that you want to delete all the monitors for ${group.planName}?`,
              type: "question",
              confirmButtonText: "Yes Proceed",
              confirmButtonColor: "#6ACF98",
              showCancelButton: true,
              cancelButtonText: "No Thanks",
              cancelButtonColor: "#EE8057"
            })
                .then(async result => {
                  if (result.value) {
                    const resp = await this.$http.post("zabbix/monitor", {
                      grant_type: "token",
                      "action": "delete_group",
                      "hostname": hbHostname
                    });
                    console.log('response received', resp.data)
                    if (resp.data.success) {
                      const ref = await db.collection('zabbixMonitors').where('serverIP', '==', group.serverIP).get();
                      for (const row of ref.docs) {
                        await db.collection('zabbixMonitors').doc(row.id).delete();
                      }
                      this.showToast({
                        duration: 8000,
                        message: `You have successfully ${type}d the ${group.planName}.`
                      }, true, 'success')

                    }
                  }
                })
          }
        }
      } catch (e) {
        console.log('error ', e.toString())
        this.showToast({
          duration: 8000, message: `Something went wrong while ${type.replace('e', '')}ing ${group.planName}.`
        }, true, 'danger')
      } finally {
        this.selectedIndex = -1
        this.selectedPlanLoading = ''
      }

    },
    getHash(nam) {
      const obj = this.allMembers.find(el => `${el.firstName} ${el.lastName}` === nam);
      let hash = ''
      if (obj) {
        hash = md5(obj.email.trim().toLowerCase()).toString()
      }
      return hash
    },
    async getAdmins() {
      const ref = await db.collection("users").where("userType", "in", ['admin', 'manager', 'super-admin']).get();
      if (ref.size) {
        ref.forEach(el => {
          this.allMembers.push({uid: el.id, ...el.data()})
        })
      }
    },
    getWPOPlanClass(group) {
      const plan = this.getWPOPlan(group);
      let className = ''
      if (plan.toLowerCase().includes('starter')) {
        className = 'badge-success'
      } else if (plan.toLowerCase().includes('professional')) {
        className = 'badge-warning'
      } else if (plan.toLowerCase().includes('enterprise')) {
        className = 'badge-primary'
      } else if (plan.toLowerCase().includes('business')) {
        className = 'business'
      } else if (plan.toLowerCase().includes('dedicated')) {
        className = 'badge-default'
      } else if (plan.toLowerCase().includes('managed wordpress')) {
        className = 'managedWP'
      } else if (plan.toLowerCase().includes('vps')) {
        className = 'vps'
      } else if (plan.toLowerCase().includes('journey')) {
        className = 'journey'
      } else if (plan.toLowerCase().includes('mediavine plan 1')) {
        className = 'mediavinePlan1'
      } else if (plan.toLowerCase().includes('mediavine plan 2')) {
        className = 'mediavinePlan1'
      } else if (plan.toLowerCase().includes('mediavine plan 3')) {
        className = 'mediavinePlan1'
      } else if (plan.toLowerCase().includes('mediavine enterprise')) {
        className = 'mediavinePlan1'
      } else if (plan.toLowerCase().includes('north commerce starter')) {
        className = 'badge-info'
      }
      return className
    },
    getWPOPlan(group) {
      const plan = group.tests.find(el => el.wpoPlan);
      return plan && plan.wpoPlan ? plan.wpoPlan.replace('WPO', '') : ''
    },
    getActiveJobTitle(test) { //  'Active backup CREATE process running': 'Active backup RESTORE process running'
      const domain = this.showDomainName(test.url)
      if (test.taskResolvedAt) {
        const dateObject = new Date(test.taskResolvedAt);

        // Get current time
        const currentTime = new Date();

        // Calculate the time difference in milliseconds
        const timeDifference = currentTime - dateObject;

        // Convert time difference to hours
        const minutesDifference = timeDifference / (1000 * 60);
        if (minutesDifference <= 60) {
          return `Possible DNS propagation or SSL issue. Site was added ${Math.ceil(minutesDifference)} minutes ago.`
        }
      }
      const activeM = this.activeMigrationList.find(el => el.domain === domain)
      if (activeM) {
        return 'Active migration request exists in WPO.'
      }
      const activeJob = this.activeJobsDomainList.find(el => (el.jobName !== 'set-php-version' && el.jobData.ip === test.serverIP))
      if (activeJob) {
        switch (activeJob.jobName) {
          case 'backup-job':
            return activeJob.operation === 'create' ? 'Active Backup CREATE process running' : 'Active Backup RESTORE process running'
          case 'staging-job':
            return 'Active STAGING job running'
          case 'cloning':
            return 'Active CLONE job running'
          case 'set-php-version':
            return `Potential PHP version conflict. PHP Version was updated to ${activeJob.jobData.phpVersion} from ${activeJob.jobData.prevPhpVersion} - ${moment(new Date(activeJob.createdAt)).fromNow()}.`
          default:
            return ''
        }
      }
    },
    getPhpJobTitle(test) { //  'Active backup CREATE process running': 'Active backup RESTORE process running'
      const domain = this.showDomainName(test.url)
      const activeJob = this.activeJobsDomainList.find(el => (el.jobName === 'set-php-version' && el.domain === domain))
      if (activeJob) {
        switch (activeJob.jobName) {
          case 'set-php-version':
            return `Potential PHP version conflict. PHP Version was updated to ${activeJob.jobData.phpVersion} from ${activeJob.jobData.prevPhpVersion} - ${moment(new Date(activeJob.createdAt)).fromNow()}.`
          default:
            return ''
        }
      } else {
        const lastIncident = test.incidents[test.incidents.length - 1]
        if (!lastIncident.start) {
          return
        }
        const date = lastIncident.start
        let earlierDate60Min = new Date(new Date(lastIncident.start).getTime() - (60 * 60 * 1000)).toISOString();
        const obj1 = this.completedJobsDomainList.find(el => {
          return el.jobName === 'set-php-version' && (el.createdAt <= date && el.createdAt >= earlierDate60Min) && (el.domain === domain)
        })
        if (obj1) {
          return `Potential PHP version conflict. PHP Version was updated to ${obj1.jobData.phpVersion} from ${obj1.jobData.prevPhpVersion} - ${moment(new Date(obj1.createdAt)).fromNow()}.`
        }
      }
    },
    getCompletedJobTitle(test) { //  'Active backup CREATE process running': 'Active backup RESTORE process running'
      let domain = this.showDomainName(test.url);
      const lastIncident = test.incidents[test.incidents.length - 1]
      if (!lastIncident.start) {
        return
      }
      const date = lastIncident.start
      let earlierDate = new Date(new Date(lastIncident.start).getTime() - (30 * 60 * 1000)).toISOString();
      let earlierDate60Min = new Date(new Date(lastIncident.start).getTime() - (60 * 60 * 1000)).toISOString();
      const job = this.completedJobsDomainList.find(el => {
        return el.jobName !== 'set-php-version' && (el.createdAt <= date && el.createdAt >= earlierDate) && (el.jobData.ip === test.serverIP)
      })
      if (job) {
        switch (job.jobName) {
          case 'backup-job':
            return job.operation === 'create' ? 'Backup CREATE process was running' : 'Backup RESTORE process was running'
          case 'staging-job':
            return 'STAGING job was running'
          case 'cloning':
            return 'CLONE job was running'
          case 'set-php-version':
            return `Potential PHP version conflict. PHP Version was updated to ${job.jobData.phpVersion} from ${job.jobData.prevPhpVersion} - ${moment(new Date(job.createdAt)).fromNow()}.`
          default:
            return ''
        }
      }
    },
    checkActiveJob(test) {
      let domain = this.showDomainName(test.url);
      if (test.taskResolvedAt) {
        const dateObject = new Date(test.taskResolvedAt);

        // Get current time
        const currentTime = new Date();

        // Calculate the time difference in milliseconds
        const timeDifference = currentTime - dateObject;

        // Convert time difference to hours
        const minutesDifference = timeDifference / (1000 * 60);
        if (minutesDifference <= 60) {
          return true
        }
      }
      return this.activeMigrationList.find(el => el.domain === domain) || this.activeJobsDomainList.find(el => (el.jobName !== 'set-php-version' && el.jobData.ip === test.serverIP))
    },
    checkPhpJob(test) {
      let domain = this.showDomainName(test.url);
      const obj = this.activeJobsDomainList.find(el => (el.jobName === 'set-php-version' && el.domain === domain))
      if (obj) {
        return true
      } else {
        const lastIncident = test.incidents[test.incidents.length - 1]
        if (!lastIncident.start) {
          return
        }
        const date = lastIncident.start
        let earlierDate60Min = new Date(new Date(lastIncident.start).getTime() - (60 * 60 * 1000)).toISOString();
        const obj1 = this.completedJobsDomainList.find(el => {
          return el.jobName === 'set-php-version' && (el.createdAt <= date && el.createdAt >= earlierDate60Min) && (el.domain === domain)
        })
        return !!obj1
      }
    },
    checkCompletedJob(test) {
      const lastIncident = test.incidents[test.incidents.length - 1]
      if (!lastIncident.start) {
        return
      }
      const date = lastIncident.start
      let earlierDate = new Date(new Date(lastIncident.start).getTime() - (30 * 60 * 1000)).toISOString();
      let earlierDate60Min = new Date(new Date(lastIncident.start).getTime() - (60 * 60 * 1000)).toISOString();
      let domain = this.showDomainName(test.url);
      const obj = this.completedJobsDomainList.find(el => {
        return el.jobName !== 'set-php-version' && (el.createdAt <= date && el.createdAt >= earlierDate) && (el.jobData.ip === test.serverIP)
      })
      return !!obj
    },
    pendingJobs() {
      const allowedOperations = ['create', 'restore']
      const query = db.collection('jobLogs')
          .where('status', '==', 'running')
          .where('jobName', 'in', ['backup-job', 'staging-job', 'cloning', 'set-php-version'])
          .orderBy("createdAt", "desc");

      this.pendingJobListener = query.onSnapshot(snapshot => {
        snapshot.docChanges().forEach((change) => {
          const data = change.doc.data()
          if (change.type === 'added') {
            if (data.jobName !== 'backup-job' || (data.jobName === 'backup-job' && allowedOperations.includes(data.jobData.operation))) {
              this.activeJobsDomainList.push({
                jobName: data.jobName,
                domain: data.inputDomain,
                operation: data.jobData.operation || '',
                jobData: data.jobData
              })
            }
          } else if (change.type === 'removed') {
            if (data.jobName !== 'backup-job' || (data.jobName === 'backup-job' && allowedOperations.includes(data.jobData.operation))) {
              this.activeJobsDomainList = this.activeJobsDomainList.filter(d => {
                return !(d.domain === data.inputDomain && d.jobName === data.jobName)
              })
            }
          }
        })
      });
    },
    activeMigrations() {
      const allowedStatus = ['pending']
      let ref = db
          .collection("savedMigrations")
          .where('status', 'in', allowedStatus)

      this.migrationListener = ref.onSnapshot(snapshot => {
        snapshot.docChanges().forEach((change) => {
          const data = change.doc.data()
          if (change.type === 'added') {
            this.activeMigrationList.push({
              domain: data.siteDetails.domainName,
              status: data.status || '',
            })
          } else if (change.type === 'removed') {
            this.activeMigrationList = this.activeMigrationList.filter(d => {
              return !(d.domain === data.siteDetails.domainName)
            })
          }
        })
      });
    },
    completedJobs() {
      let date = new Date()
      date.setDate(date.getDate() - 1);
      const allowedOperations = ['create', 'restore']
      const query = db.collection('jobLogs')
          .where('status', '==', 'complete')
          .where('jobName', 'in', ['backup-job', 'staging-job', 'cloning', 'set-php-version'])
          .where('createdAt', ">=", date.toISOString())
          .orderBy("createdAt", "desc");

      this.completeJobListener = query.onSnapshot(snapshot => {
        snapshot.docChanges().forEach((change) => {
          const data = change.doc.data()
          if (change.type === 'added') {
            if (data.jobName !== 'backup-job' || (data.jobName === 'backup-job' && allowedOperations.includes(data.jobData.operation))) {
              this.completedJobsDomainList.push({
                jobName: data.jobName,
                domain: data.inputDomain,
                operation: data.jobData.operation || '',
                createdAt: data.createdAt,
                jobData: data.jobData
              })
            }
          } else if (change.type === 'removed') {
            if (data.jobName !== 'backup-job' || (data.jobName === 'backup-job' && allowedOperations.includes(data.jobData.operation))) {
              this.completedJobsDomainList = this.completedJobsDomainList.filter(d => {
                return !(d.domain === data.inputDomain && d.jobName === data.jobName)
              })
            }
          }
        })
      });
    },
    checkOption(event) {
      console.log(event)
      const {tag} = event.target._value;
      if (tag === 'all') {
        // check all tags
        if (this.selectedFilters && this.selectedFilters.length) {
          this.selectedFilters = []
          this.notInWPOFilter = false;
        } else {
          this.notInWPOFilter = true
          this.selectedFilters = this.filteredOptions.slice(1, -1)
        }
        console.log('selected filters', this.selectedFilters)
      }
      // else if(tag === 'none') {
      //   this.selectedFilters = []
      //   this.selectedFilters.push(this.filteredOptions[this.filteredOptions.length - 1])
      // } else {
      //   // remove all and none from array
      //   const index = this.selectedFilters.findIndex(el => el.tag === 'all' )
      //   if (index !== -1) {
      //     this.selectedFilters.splice(index, 1)
      //   }
      //   const noneIndex = this.selectedFilters.findIndex(el => el.tag === 'none' )
      //   if (noneIndex !== -1) {
      //     this.selectedFilters.splice(noneIndex, 1)
      //   }
      // }

    },
    changeCauseLength(test) {
      this.$set(this.tracker, test.id, !this.tracker[test.id]);
      // if(this.tracker[test]){
      // }
      // else{
      //   this.$set(this.tracker, test.id, true);
      // }
      console.log('trackers', this.tracker)
    },
    getProperty(property) {
      return this.tracker[property] || false;
    },
    showDomainName(url) {
      let domainName = url.replace('https://', '').replace('/?v={timestamp}', '');
      // if (domainName.length > 22) {
      //   return [domainName.slice(0,22), domainName.slice(22,domainName.length)]
      // }
      domainName = domainName.split('/?')[0]
      return domainName

    },
    checkDownTime(test) {
      const {start} = test.incidents[test.incidents.length - 1]
      const givenDate = moment(start, 'HH:mm:ss YYYY.MM.DD').tz("America/New_York");
      const currentTime = moment(new Date()).tz("America/New_York").format('HH:mm:ss YYYY.MM.DD');
      const diffMs = Math.abs(givenDate.diff(currentTime));
      const duration = moment.duration(diffMs);
      console.log('down tiemme', duration.format('mm'))
      return duration.format("mm")
      // return (new Date() - new Date(test.incidents[test.incidents.length - 1].start))/60000
    },
    getScreenshotUrl(test) {
      return test.incidents[test.incidents.length - 1].screenshotUrl;
    },
    getEffectiveUrl(test) {
      return this.allowedTabs.includes(this.datatableId) ? test.incidents[test.incidents.length - 1].incident_timestamp_url || '' : test.incidents[test.incidents.length - 1].effective_url || test.url;
    },
    getResponseUrl(test) {
      const incident = test.incidents[test.incidents.length - 1] || {};
      return incident.responseUrl && incident.responseUrl.includes('zabbix.bigscoots.dev') ? incident.responseUrl : '' || '';
    },
    getAcknowledgeBy(test) {
      if (test.incidents && test.incidents.length) {
        return test.incidents[test.incidents.length - 1].acknowledgedBy || ''
        // const incidents = JSON.parse(JSON.stringify(test.incidents))
        // const obj = incidents.reverse().find(inc => !!inc.id);
        // if (obj && obj.acknowledgedBy) {
        //   return obj.acknowledgedBy
        // }
      }
      return false
    },
    async saveInDBAndShowSuccess(test, ack_by, noTicket) {
      // test.incidents[test.incidents.length - 1].acknowledgedBy = ack_by
      // const incidentId = test.incidents[test.incidents.length - 1].id
      // if (!incidentId) {
      // await db.collection('monitors').doc(test.id).update({
      //   incidents: test.incidents,
      //   lastAckBy: ack_by,
      //   LastAckAt: new Date().toISOString()
      // })
      // }

      this.selectedMonitorLoading = null
      if (!noTicket) {
        // swal({
        //   title: 'Success!',
        //   text: 'You have successfully acknowledged the monitor. Would you like to create a ticket for this monitor?',
        //   type: 'success',
        //   showCancelButton: true,
        //   confirmButtonColor: "#6ACF98",
        //   cancelButtonColor: "#EE8057",
        //   confirmButtonText: "Yes Proceed",
        //   cancelButtonText: "No Thanks",
        // }).then((result) => {
        //   if(result.value) {
        //     this.openTicketModal(test, 'checkin')
        //   }
        // })
      }
    },
    async bulkAcknowledgeV2(group, acknowledgedBy, noIncrement = null) {
      try {
        console.log('this   ', this.datatableId)
        this.selectedIndex = group.index
        const encryptedEmail = this.user.email ? md5(this.user.email.trim().toLowerCase()).toString() : '';
        const result = await this.$http.post('/monitor/bulk-acknowledge', {
          grant_type: 'token',
          type: this.allowedTabs.includes(this.datatableId) ? 'zabbix' : '',
          group,
          acknowledgedBy,
          noIncrement, encryptedEmail
        });
        // swal({
        //   title: 'Success!',
        //   text: 'You have successfully acknowledged the monitor. Would you like to create a ticket for this monitor?',
        //   type: 'success',
        //   showCancelButton: true,
        //   confirmButtonColor: "#6ACF98",
        //   cancelButtonColor: "#EE8057",
        //   confirmButtonText: "Yes Proceed",
        //   cancelButtonText: "No Thanks",
        // }).then((result) => {
        //   if(result.value) {
        //     this.openTicketModal(group.tests[0], 'checkin')
        //   }
        // })
      } catch (e) {
        console.log('Error Occurred', e.toString())
      } finally {
        this.selectedIndex = -1
      }
    },
    async bulkAcknowledge(group, acknowledgedBy, noIncrement) {
      try {
        const firstCheckin = !group.tests.find(el => {
          return el.incidents[el.incidents.length - 1].acknowledgedBy
        });
        this.selectedPlanLoading = group.planName
        for (const row of group.tests) {
          const lastObj = row.incidents[row.incidents.length - 1]
          if (!lastObj.acknowledgedBy && lastObj.status === 'down') {
            console.log('monitor to be processed', row.id)
            await this.acknowledge(row, acknowledgedBy, true)
          }
        }
        if (!noIncrement) {
          try {
            await this.incrementCountBasedOnType(this.user, 'monitor')
            const data = {
              ticketId: group.uid,
              taskId: group.uid,
              type: 'info',
              message: `${this.user.firstName} ${this.user.lastName} has checked in Monitor ${group.uid}.`,
              actionType: 'monitor',
              customer: {
                domain: group.uid,
              }
            }
            // await this.addToAdminActiveTask({...data})
            await this.addRecentActivity({...data})
          } catch (e) {
            console.log('line 1016', e.toString())
          }
        }
        if (firstCheckin) {
          console.log('firstCheckin')
          // swal({
          //   title: 'Success!',
          //   text: 'You have successfully acknowledged the monitor. Would you like to create a ticket for this monitor?',
          //   type: 'success',
          //   showCancelButton: true,
          //   confirmButtonColor: "#6ACF98",
          //   cancelButtonColor: "#EE8057",
          //   confirmButtonText: "Yes Proceed",
          //   cancelButtonText: "No Thanks",
          // }).then((result) => {
          //   if(result.value) {
          //     this.openTicketModal(group.tests[0], 'checkin')
          //   }
          // })
        }
        this.selectedPlanLoading = null
      } catch (e) {
        this.selectedPlanLoading = null
        console.log('error while acknowledging', e.toString())
      }
    },
    async acknowledge(test, acknowledgedBy, noTicket) {
      // const incidents = JSON.parse(JSON.stringify(test.incidents))
      // const obj = incidents.reverse().find(inc => !!inc.id);
      let incidentId = test.incidents[test.incidents.length - 1].id || ''
      const acknowledgedByName = acknowledgedBy ? acknowledgedBy : !noTicket ? this.user.firstName + ' ' + this.user.lastName : ''
      try {
        this.selectedMonitorLoading = test.id
        // save acknowledged by in db
        if (acknowledgedByName) {
          test.incidents[test.incidents.length - 1].acknowledgedBy = acknowledgedByName;
          test.incidents[test.incidents.length - 1].acknowledgedAdminEmail = this.user.email;
          await db.collection('monitors').doc(test.id).update({
            incidents: test.incidents
          })
        }
        // if(!obj) {
        //   swal({
        //     title: "Error!",
        //     text: 'No incident id exists!',
        //     type: "error",
        //     confirmButtonText: "Try Again!",
        //     confirmButtonColor: "#EE8057"
        //   });
        //   return false
        // }
        if (incidentId && acknowledgedByName && !noTicket) {
          await this.$http.post("monitor/acknowledge/incident", {
            grant_type: "token",
            token: this.userToken,
            incidentId: incidentId,
            acknowledgedBy: acknowledgedByName
          })
          if (!noTicket) {
            try {
              await this.incrementCountBasedOnType(this.user, 'monitor')
              try {
                const data = {
                  ticketId: test.id,
                  taskId: test.id,
                  type: 'info',
                  message: `${this.user.firstName} ${this.user.lastName} has checked in Monitor ${test.name}.`,
                  actionType: 'monitor',
                  customer: {
                    domain: this.showDomainName(test.url),
                  }
                }
                // await this.addToAdminActiveTask({...data})
                await this.addRecentActivity({...data})
              } catch (e) {
                console.log('unable to save recent activity', e.toString())
              }

            } catch (e) {
              console.log('line 1063', e.toString())
            }
          }
        }
        if (acknowledgedByName) {
          await this.saveInDBAndShowSuccess(test, acknowledgedByName, noTicket)
        }
      } catch (err) {
        let errorMessage = 'Something went wrong while acknowledging the monitor';
        if (!err || !err.response || err.response.status !== 409) {
          test.incidents[test.incidents.length - 1].acknowledgedBy = ''
          await db.collection('monitors').doc(test.id).update({incidents: test.incidents})
          if (!noTicket) {
            swal({
              title: "Error!",
              text: errorMessage,
              type: "error",
              confirmButtonText: "Try Again!",
              confirmButtonColor: "#EE8057"
            });
          }
        }

      } finally {
        this.selectedMonitorLoading = null
      }

    },
    checkStatusCake(test, statusCake) {
      if ((test.status === 'up' || test.status === 'down') && statusCake.toLowerCase() === 'active') {
        return true
      } else if (!(test.status === 'up' || test.status === 'down')) {
        if (test.statusCake && test.statusCake.toLowerCase() === statusCake.toLowerCase()) {
          return true
        } else if (!test.statusCake && (test.status === 'up' || test.status === 'down') && statusCake.toLowerCase() === 'active') {
          return true
        } else if (!test.statusCake && test.status === 'paused' && statusCake.toLowerCase() === 'suspended') {
          return true
        } else if (!test.statusCake && test.status === 'pending' && statusCake.toLowerCase() === 'pending') {
          return true
        }
      }
      return false
    },
    async getStatusList() {
      this.statusList = []
      const ref = await db.collection('permissions').doc('betteruptime-monitor-settings').get()
      if (ref.exists) {
        this.statusList.push({status: 'Active'})
        this.statusList.push({status: 'Pending'})
        this.statusList = this.statusList.concat(ref.data().settings);
      }
    },
    async openTicketModal(group, from) {
      this.loadingOfTicket = {flag: true, id: group.id};
      await this.$parent.$refs.ticketModal.load(this.presetMacros, group, from)
    },
    openAffectedNodesAndRacksModal(type) {
      this.$parent.$refs.nodes.load(this.affectedNodes, this.allNodes, type)
    },
    async removeZabbixMonitor(test, group) {
      try {
        swal({
          title: "Are you sure?",
          text: `Are you sure you want to delete this test?`,
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        }).then(async result => {
          if (result.value) {
            this.removeItem = test;
            this.action = 'remove';
            const resp = await this.$http.post("zabbix/monitor", {
              grant_type: "token",
              action: 'delete',
              monitor_id: test.id
            })
            console.log('resp', resp.data);
            if (resp.data.success) {
              // await db.collection('zabbixMonitors').doc(test.id).delete();
              this.showToast({message: 'You have successfully deleted monitor.'}, true, {type: 'success'})
            }
          }
        })
      } catch (e) {
        console.log('error while removing zabbix monitor', e.toString());
        this.showToast({message: 'Something went wrong while removing zabbix monitor'}, true, {type: 'danger'})
      } finally {
        this.removeItem = null;
        this.action = '';
      }
    },
    remove(test, group) {
      swal({
        title: "Are you sure?",
        text: `Are you sure you want to delete this test?`,
        type: "question",
        confirmButtonText: "Yes Proceed",
        confirmButtonColor: "#6ACF98",
        showCancelButton: true,
        cancelButtonText: "No Thanks",
        cancelButtonColor: "#EE8057"
      })
          .then(async result => {
            if (result.value) {
              this.removeItem = test;
              this.action = 'remove';
              try {
                await this.$http.post("monitor/delete/test", {
                  grant_type: "token",
                  token: this.userToken,
                  testId: test.id
                })
              } catch (err) {
                console.log(err.toString())
              }
              try {
                await db.collection('monitors').doc(test.id.toString()).delete();
                // await this.removeAdminActiveTask({taskId:test.id})
                await this.startGrouping();
                this.addLog({
                  primaryPlan: 'Account Based Operation',
                  message: `Monitor test has been deleted, TestId: ${test.id}, Test Name: ${test.name}`,
                  level: "info"
                })
                if (group) {
                  group.tests = group.tests.filter(t => t.id !== test.id)
                }
              } catch (err) {
                let responseMessage = err.response.data.message;
                if (err.response.status === 422) {
                  responseMessage = _.map(err.response.data.errors, 'msg').join('. ')
                } else if (err.response.status === 401) {
                  responseMessage = "You need update token. Please Try Again!";
                  this.refreshToken();
                }
                swal({
                  title: "Something went wrong!",
                  html: responseMessage,
                  type: "error",
                  confirmButtonText: "Try Again!",
                  confirmButtonColor: "#EE8057"
                });
                this.addLog({
                  name: this.user.firstName + " " + this.user.lastName,
                  message: "Error delete monitor test. Message: " + responseMessage,
                  level: "danger"
                });
              } finally {
                this.action = null;
                this.removeItem = null;
              }
            }
          });
    },
    pause(test, pauseValue) {
      this.updateItem = test;
      this.action = 'update';
      this.$http.post("domain/update/monitor_test", {
        grant_type: "token",
        token: this.userToken,
        data: {
          testID: test.id,
          paused: pauseValue == 0 ? false : true
        }
      })
          .then(() => {
            if (pauseValue === 0) {
              console.log('Un - Pausing....');
              this.$http.post('/monitor/get_test', {
                grant_type: "token",
                token: this.userToken,
                testId: test.id,
              }).then(resp => {
                let testData = resp.data.test.data.attributes;
                console.log('testData', testData)
                if (!testData.ErrNo) {
                  test.status = testData.status;
                  if (test.statusCake === 'Active') {
                    if (testData.paused) {
                      test.statusCake = 'Other'
                    } else if (test.status === 'pending') {
                      test.statusCake = '15Min'
                    }
                  }
                  if (testData.status !== 'paused') {
                    test.incidents[test.incidents.length - 1].end = new Date().toISOString();
                    test.incidents.push({
                      start: new Date().toISOString(),
                      status: testData.status,
                      statusCode: (testData.status === 'up') ? 200 : 0,
                    });
                  }
                  // test.upTime = testData.Uptime;
                  test.updatedAt = new Date().toISOString();
                  if (testData.status === 'down') {
                    test.downCount += 1;
                  }
                }
                console.log(test);
                db.collection('monitors').doc(test.id.toString()).update(test);

                this.addLog({
                  primaryPlan: 'Account Based Operation',
                  message: `Monitor test has been unpaused, TestId: ${test.id}, Test Name: ${test.name}`,
                  level: "info"
                })
              });
            } else {
              console.log('Pausing....');
              db.collection('monitors').doc(test.id.toString()).update({status: 'paused'});
            }
          })
          .catch((err) => {
            console.error(err);
            let responseMessage = err.response.data.message;
            if (err.response.status === 422) {
              responseMessage = _.map(err.response.data.errors, 'msg').join('. ')
            } else if (err.response.status === 401) {
              responseMessage = "You need update token. Please Try Again!";
              this.refreshToken();
            }
            swal({
              title: "Something went wrong!",
              html: responseMessage,
              type: "error",
              confirmButtonText: "Try Again!",
              confirmButtonColor: "#EE8057"
            });
            this.addLog({
              name: this.user.firstName + " " + this.user.lastName,
              message: "Error StatusCake pause. Message: " + responseMessage,
              level: "danger"
            });
          })
          .finally(() => {
            this.action = null;
            this.updateItem = null;
          });

    },
    updateStatusCakeValue(test, e) {
      console.log(e.target.value);
      console.log(test);
      console.log('Adding status cake value in: ' + test.id);
      if (test.notes === undefined) {
        test.notes = [];
      }
      test.notes.push({
        noteDate: new Date().toISOString(),
        note: e.target.value,
        noteAddedBy: this.user.firstName + ' ' + this.user.lastName
      });
      if (e.target.value.toLowerCase() === 'suspended') {
        test.note = 'Suspended'
        test.hbSuspended = true;
      }
      test.statusCake = e.target.value;
      test.updatedAt = new Date().toISOString();
      if (this.allowedTabs.includes(this.datatableId)) {
        if (e.target.value.toLowerCase() === 'active') {
          test.status = test.incidents[test.incidents.length - 1].status
        } else {
          test.status = 'paused'
        }
        db.collection('zabbixMonitors').doc(test.id.toString())
            .update(test)
            .then(() => {
              if (e.target.value.toLowerCase() === 'active') {
                const incidentId = test.incidents[test.incidents.length - 1].id;
                console.log('incidentId', incidentId)
                console.log('resolving incident')
                this.$http.post("zabbix/monitor", {
                  grant_type: "token",
                  action: 'unpause',
                  monitor_id: test.id
                })
              } else {
                this.$http.post("zabbix/monitor", {
                  grant_type: "token",
                  action: 'pause',
                  monitor_id: test.id
                })
              }
            }).catch(() => {
          this.addLog({
            message: `Error in updating test status value!`,
            level: "danger"
          })
          swal('Error', 'Error in updating test status!', 'error');
        });
      } else {
        db.collection('zabbixMonitors').doc(test.id.toString())
            .update(test)
            .then(() => {
              if (e.target.value.toLowerCase() === 'active') {
                const incidentId = test.incidents[test.incidents.length - 1].id;
                console.log('incidentId', incidentId)
                if (incidentId) {
                  console.log('resolving incident')
                  this.$http.post("zabbix/monitor", {
                    grant_type: "token",
                    action: 'unpause',
                    monitor_id: test.id
                  })
                }
              } else {
                this.$http.post("zabbix/monitor", {
                  grant_type: "token",
                  action: 'pause',
                  monitor_id: test.id
                })
              }
            }).catch(() => {
          this.addLog({
            message: `Error in updating status cake value!`,
            level: "danger"
          })
          swal('Error', 'Error in updating status cake value!', 'error');
        });
      }
    },
    clickedIpSort() {
      if (!this.ipSortType) {
        this.ipSortType = 'desc'
      } else if (this.ipSortType === 'desc') {
        this.ipSortType = 'asc'
      } else {
        this.ipSortType = null
      }
    },
    clickedDowntimeSort() {
      if (!this.downtimeType) {
        this.downtimeType = 'desc'
      } else if (this.downtimeType === 'desc') {
        this.downtimeType = 'asc'
      } else {
        this.downtimeType = null
      }
    },
    clickedOutageSort() {
      if (!this.outageSortType) {
        this.outageSortType = 'desc'
      } else if (this.outageSortType === 'desc') {
        this.outageSortType = 'asc'
      } else {
        this.outageSortType = null
      }
    },
    clickedRackSort() {
      if (!this.rackSortType) {
        this.rackSortType = 'desc'
      } else if (this.rackSortType === 'desc') {
        this.rackSortType = 'asc'
      } else {
        this.rackSortType = null
      }
    },
    clickedNodeSort() {
      if (!this.nodeSortType) {
        this.nodeSortType = 'desc'
      } else if (this.nodeSortType === 'desc') {
        this.nodeSortType = 'asc'
      } else {
        this.nodeSortType = null
      }
    },
    clickedPlanSort() {
      if (!this.planSortType) {
        this.planSortType = 'desc'
      } else if (this.planSortType === 'desc') {
        this.planSortType = 'asc'
      } else {
        this.planSortType = null
      }
    },
    clickedStatusSort() {
      if (!this.statusSortType) {
        this.statusSortType = 'desc'
      } else if (this.statusSortType === 'desc') {
        this.statusSortType = 'asc'
      } else {
        this.statusSortType = null
      }
    },
    nextPage() {
      this.pageNumber++;
    },
    prevPage() {
      this.pageNumber--;
    },
    goToPage(pageNum) {
      this.pageNumber = pageNum - 1;
      setTimeout(() => {
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
      }, 300)
    },
    getNoteTooltip(data) {
      let tooltip = ''
      if (data.noteAddedAt) {
        tooltip += moment(data.noteAddedAt).format("DD MMM, YYYY HH:mm:ss")
      }
      return tooltip
    },
    async getAllNodes() {
      try {
        let nodesResp = await db.collection('netboxNodes').get()
        this.allNodes = {}
        nodesResp.forEach(el => {
          this.allNodes[el.id] = el.data()
          // this.allNodes.push({id:el.id, ...el.data()})
        })
      } catch (e) {
        console.log('error', e.toString())
      }
    },
    doCopy(item) {
      this.$copyText(item).then(() => {
        this.$notify({
          group: 'foo',
          title: 'Message',
          text: 'Copied!'
        });
      }, function (e) {
        console.log(e)
      });
    },
    async renderDatatable(group, type) {
      group.showTests = !group.showTests
      if (type === 'openedGroups') {
        // let openedGroups = [];
        // if (localStorage.getItem('openedGroups')) {
        //   openedGroups = JSON.parse(localStorage.getItem('openedGroups'))
        // }
        if (group.showTests) {
          this.openedGroups.push(group.planName)
        } else {
          this.openedGroups.splice(this.openedGroups.indexOf(group.planName), 1)
        }
        // localStorage.setItem('openedGroups', JSON.stringify(openedGroups))
      }
      let self = this
      if (type == 'ungrouped') {
        // $(`#${this.datatableId}-ungrouped`).DataTable().destroy();
        // setTimeout(function () {
        //   $(`#${self.datatableId}-ungrouped`).dataTable({
        //     // pagingType: "full_numbers",
        //     "bPaginate": false, //hide pagination
        //     "bFilter": false, //hide Search bar
        //     destroy: true,
        //     retrieve: true,
        //     deferRender: true,
        //     stateSave: true,
        //     "bInfo" : false,
        //     "ordering": false,
        //     // order: [[2, "asc"]],
        //     // 'columnDefs': [ {
        //     //   'targets': [0,1, -1,7], /* column index */
        //     //   'orderable': false, /* true or false */
        //     // }]
        //   });
        // }, 0)
      }
      // else{
      //   group.showTests = !group.showTests
      //   let id=group.planName==='(N/A)' ? `${this.datatableId}-unavailable` : `${this.datatableId}-${group.planName}`
      //   if(id.includes('.com')){
      //     id= id.split('.')[0]
      //   }
      //   if(group.showTests){
      //     if($.fn.DataTable.isDataTable( `#${id}`)){
      //       $(`#${id}`).DataTable().destroy()
      //
      //     }
      //     $(`#${id}`).dataTable({
      //       pagingType: "full_numbers",
      //       destroy: true,
      //       retrieve: true,
      //       deferRender: true,
      //       stateSave: true,
      //       "ordering": true,
      //       order: [[2, "asc"]],
      //       'columnDefs': [ {
      //         'targets': [0,1, -1,7], /* column index */
      //         'orderable': false, /* true or false */
      //       }]
      //     });
      //   }
      // }
      setTimeout(() => {
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
      }, 300)
    },
    getTotalOutages(group) {
      return group.tests.reduce((a, b) => a + (b.downCount || 0), 0);
    },
    findUser(group) {
      if (group.uid) {
        // let customers = localStorage.getItem('customers') ? JSON.parse(localStorage.getItem('customers')) : [];
        // let user = find(customers, {'docID': uid});
        swal({
          title: group.firstName + ' ' + group.lastName,
          text: 'Would you like to login to this customer\'s WPO account',
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        }).then(result => {
          if (result.value) {
            this.goToNuxt(group.uid);
          }
        });
      } else {
        swal("Not Found!", 'Plan is not found in the WPO', 'error');
      }
    },
    async openHbProfile(test) {
      if (test.nonWpoMonitor) {
        if (test.clientId) {
          window.open(`https://portal.bigscoots.com/admin/?cmd=clients&action=show&id=${test.clientId}`, '_blank')
        }
        return true
      }
      const ref = await db.collection('users').doc(test.uid).get();
      if (ref.exists) {
        const {customerID} = ref.data()
        window.open(`https://portal.bigscoots.com/admin/?cmd=clients&action=show&id=${customerID}`, '_blank')
      }
    },
    viewClientTickets(test) {
      console.log('caling')
      if (test.nonWpoMonitor) {
        if (test.clientId) {
          window.open(`https://portal.bigscoots.com/admin/?cmd=clients&action=show&id=${test.clientId}&open_tab=11`, '_blank')
        }
        return true
      }
      const ref = db.collection('users').doc(test.uid).get().then(resp => {
        if (resp.exists) {
          const {customerID} = resp.data()
          window.open(`https://portal.bigscoots.com/admin/?cmd=clients&action=show&id=${customerID}&open_tab=11`, '_blank')
        }
      });

    },
    openModal(test, el) {
      if (el === 'viewEventsModal') {
        this.$parent.selectedItemForView = _.cloneDeep(test);
        this.$parent.eventsShowAll = false
        this.$parent.notesShowAll = false
        this.$parent.notesPageSize = 5
        this.$parent.notesPageNumber = 0
        this.$parent.pageNumber = 0
        this.$parent.pageSize = 5
        this.$parent.selectedItemForView.incidents.reverse();
        if (this.$parent.selectedItemForView.notes !== undefined) {
          this.$parent.selectedItemForView.notes.reverse();
        }
        let durations = [];
        for (let event of this.$parent.selectedItemForView.incidents) {
          if (event.status === 'down' && event.end !== undefined) {
            let dur = this.timeDifferenceBetweenGivenDates(event.end, event.start);
            if (dur.split(':').length === 2) {
              durations.push("00:" + dur);
            } else if (dur.split(':').length === 1) {
              durations.push("00:00:" + dur);
            } else {
              durations.push(dur);
            }
          }
        }
        const totalDurations = moment.duration();
        durations.map(duration => {
          totalDurations.add(duration);
        });
        this.$parent.totalDownDurationOfSelectedItem = moment.utc(totalDurations.asMilliseconds()).format("HH:mm:ss");
      } else if (el === 'showTempUrl') {
        // const domainRegex = /https?:\/\/([a-zA-Z0-9.-]+\.[a-zA-Z]{2,6})/;
        // const match = test.name.match(domainRegex);
        this.$parent.$refs.tempDomainModal.load({
          domain: test.name,
          uid: test.uid,
          ip: test.serverIP,
          expiryTime: '1440'
        })

        $('.modal-backdrop').removeClass("modal-backdrop");
        return
      } else {
        if (this.allowedTabs.includes(this.datatableId)) {
          test.type = 'zabbix'
        }
        this.$parent.selectedItemForView = test;
      }
      /* eslint-disable */
      $("#" + el).modal("show");
      $('.modal-backdrop').removeClass("modal-backdrop");
      /* eslint-enable */
    },
    getTimeDiff(start) {
      // Given date (already in EST)
      const givenDate = moment(start, 'HH:mm:ss YYYY.MM.DD').tz("America/New_York");

// Get the current time in EST
      const currentTime = moment(new Date()).tz("America/New_York").format('HH:mm:ss YYYY.MM.DD');

// Calculate the absolute difference in milliseconds
      const diffMs = Math.abs(givenDate.diff(currentTime));

// Convert difference into duration
      const duration = moment.duration(diffMs);
      // this.domainDateTime[test.url] = (this.timeDifferenceBetweenGivenDates(end, start));
      return duration.format("HH:mm:ss");
    },
    startClockTicking() {
      for (let test of this.tests) {
        let start = '';
        let end = ''
        let date = new Date();
        if (this.allowedTabs.includes(this.datatableId)) {
          start = test.incidents[test.incidents.length - 1].start
          date = moment().tz('America/Chicago').format('HH:mm:ss YYYY.MM.DD');
          end = date
        } else {
          date = date.toISOString()
          start = date;
          end = test.incidents[test.incidents.length - 1].start
        }
        this.domainDateTime[test.url] = this.getTimeDiff(start)
        this.$forceUpdate();
      }
    },
    getAffectedNodes(array) {
      this.affectedNodes = []
      if (array.length > 0) {
        array.map(el => {
          if (el.netboxNodeId && el.status !== 'paused') {
            let obj = this.affectedNodes.find(row => row.id && row.id === el.netboxNodeId)
            if (obj) {
              obj.count++
            } else {
              this.affectedNodes.push({id: el.netboxNodeId, count: 1})
            }
          }
        })
      }
    },
    getAffectedRacks(array) {
      this.affectedRacks = []
      if (array.length > 0) {
        array.map(el => {
          if (el.rackId && el.status !== 'paused') {
            let obj = this.affectedRacks.find(row => row.id && row.id === el.rackId)
            if (obj) {
              obj.count++
            } else {
              this.affectedRacks.push({id: el.rackId, count: 1, nodeId: el.netboxNodeId || ''})
            }
          }
        })
      }
    },
    groupTestsInAPlan(tests) {
      console.log("tests", tests)
      this.tests = _.cloneDeep(tests);
      const testIps = ['69.162.173.212', '23.29.145.209']
      this.tests = this.tests.filter(test => {
        return !testIps.includes(test.serverIP)
      }).filter(el => el.type !== 'diskAlert')
      this.getPausedAndDownTests(_.cloneDeep(this.tests))
      this.getAffectedNodes(_.cloneDeep(this.tests))
      this.getAffectedRacks(_.cloneDeep(this.tests))
      this.startGrouping()
      $('[data-toggle="tooltip"]').tooltip('dispose');
      $(function () {
        $('[data-toggle="tooltip"]').tooltip()
      })
    },
    getPausedAndDownTests(tests) {
      this.totalPausedTests = 0
      this.totalDownTests = 0
      this.totalDownServices = 0
      this.totalPendingTests = 0
      this.totalSuspendedTests = 0
      const countedIps = []
      tests.map(el => {
        if (el.status === 'paused') {
          if (el.hbSuspended) {
            this.totalSuspendedTests++
          } else {
            this.totalPausedTests++
          }
        } else if (el.status === 'down') {
          if (!el.hbSuspended) {
            this.totalDownTests++
          } else {
            this.totalSuspendedTests++
          }
          console.log('!countedIps.includes(el.serverIP)', !countedIps.includes(el.serverIP), el)
          if (!countedIps.includes(el.serverIP)) {
            if (!el.hbSuspended) {
              this.totalDownServices++
            }
            countedIps.push(el.serverIP)
          }
        } else if (el.status === 'pending') {
          this.totalPendingTests++
        }
      })

    },
    getRackName(name) {
      if (name) {
        let rack = name
        if (rack.includes('rack')) {
          return rack.split('rack')[1]
        } else if (rack.includes('Rack')) {
          return rack.split('Rack')[1]
        } else {
          return name
        }
      }
    },
    startGrouping() {
      console.log(this.tests, 'after tests')
      // const openedGroups = localStorage.getItem('openedGroups') ? JSON.parse(localStorage.getItem('openedGroups')) : []
      this.testGroups = []
      const testIps = ['69.162.173.212', '23.29.145.209']
      this.tests = this.tests.filter(test => {
        return !testIps.includes(test.serverIP)
      })
      this.tests.map(test => {
        // const domainOwner = this.findOwnerOfDomain(test);
        const planName = test.hbSuspended ? 'Suspended' : ((test.plan) ? test.plan : '');
        let group = this.testGroups.find(g => g.planName && g.planName === planName);
        test.acknowledgedBy = this.getAcknowledgeBy(test)
        test.downTimeCalculated = this.getTimeDiff(test.incidents[test.incidents.length - 1].start)
        test.showCause = false
        if (!group) {
          group = {
            datacenter: test.datacenter || '',
            tag: test.tag || '',
            pauseGroup: false,
            notInWPO: !test.plan,
            planName: planName,
            serverIP: test.serverIP || '',
            uid: test.uid,
            firstName: test.firstName,
            lastName: test.lastName,
            nodeName: (this.allNodes[`${test.netboxNodeId}`]) ? this.allNodes[`${test.netboxNodeId}`].name || '' : '',
            rackName: (this.allNodes[`${test.netboxNodeId}`]) ? (this.allNodes[`${test.netboxNodeId}`].rack ? this.allNodes[`${test.netboxNodeId}`].rack.name : '') : '',
            tests: [test],
            showTests: this.openedGroups.includes(planName),
            downCount: (test.status === 'down') ? 1 : 0,
            pauseCount: (test.status === 'paused') ? 1 : 0,
            pendingCount: (test.status === 'pending') ? 1 : 0,
          };
          console.log('pushing')
          this.testGroups.push(group);
        } else if (group) {
          const testExist = group.tests.find(t => (t.id === test.id));
          if (!testExist) {
            group.tests.push(test);
            if (test.status === 'down') {
              group.downCount += 1;
            } else if (test.status === 'paused') {
              group.pauseCount += 1;
            } else if (test.status === 'pending') {
              group.pendingCount += 1;
            }
          } else if (testExist && testExist.status !== test.status) {
            testExist.status = test.status;
            if (test.status === 'down') {
              group.pauseCount -= 1;
              group.downCount += 1;
            } else if (testExist.status === 'paused') {
              group.pauseCount += 1;
              group.downCount -= 1;
            }
          }
          group.tests.map(groupTest => {
            const groupTestIsExist = this.tests.find(t => t.id === groupTest.id);
            if (!groupTestIsExist) {
              if (groupTest.status === 'down') {
                group.downCount -= 1;
              } else if (groupTest.status === 'paused') {
                group.pauseCount -= 1;
              } else if (groupTest.status === 'pending') {
                group.pendingCount -= 1;
              }
              group.tests = group.tests.filter(t => t.id !== groupTest.id);
            }
          })
        }
        group.pauseGroup = group.tests.every(el => {
          if (el.hbSuspended) return true
          return el.pauseGroup;
        })
      });
      this.testGroups.map(g => {
        if (g.tests.length === 1) {
          const isLastTestExist = this.tests.find(t => t.id === g.tests[0].id);
          if (!isLastTestExist) {
            this.testGroups = this.testGroups.filter(g1 => g1.planName !== g.planName);
          }
          g.downCounts = g.tests[0].downCount
          if (g.tests[0].status === 'down' && !g.tests[0].acknowledgedBy) {
            g.showCheckin = true
          }
        } else {
          g.acknowledgedByNames = [];
          g.showCheckin = false;
          if (this.status === 'Down') {
            g.tests.map(el => {
              if (el.acknowledgedBy) {
                if (!g.acknowledgedByNames.includes(el.acknowledgedBy)) {
                  g.acknowledgedByNames.push(el.acknowledgedBy)
                }
              } else {
                if (el.status === 'down') {
                  g.showCheckin = true
                }
              }
            })
          }
          console.log('show checkin', g.showCheckin)
          if (g.showCheckin) {

            // check if any down monitor and checked in
            const obj = g.tests.find(el => {
              const isAcknowledged = el.incidents[el.incidents.length - 1].acknowledgedBy;
              return el.status === 'down' && isAcknowledged
            })
            if (obj) {
              // g.tests.map(el => {
              //   const obj1 = el.incidents[el.incidents.length - 1]
              //   if (!obj1.acknowledgedBy && obj1.status === 'down') {
              //   }
              // })
              // const lastAckBy = obj.incidents[obj.incidents.length - 1].acknowledgedBy
              // this.bulkAcknowledge(g, lastAckBy, true)
              g.showCheckin = false;
            }
            // bring down monitors on top
            g.tests = g.tests.sort((a, b) =>
                a.status.localeCompare(b.status));
            // const latestObject = g.tests.reduce((latest, current) => {
            //   if (latest.LastAckAt && current.LastAckAt) {
            //     const latestDate = new Date(latest.LastAckAt);
            //     const currentDate = new Date(current.LastAckAt);
            //     return currentDate > latestDate ? current : latest;
            //   } else {
            //     return current.LastAckAt ? current : latest
            //   }
            // });
            // if (latestObject.LastAckAt) {
            //   const specificDate = new Date(latestObject.LastAckAt);
            //   const currentDate = new Date();
            //
            //   const diff = (currentDate.getTime() - specificDate.getTime()) / (60 * 1000); // difference in milliseconds
            //   if (diff < 10) {
            //     g.acknowledgedBy = latestObject.acknowledgedBy || ''
            //     g.showCheckin = false
            //     this.bulkAcknowledge(g, latestObject.acknowledgedBy, true)
            //   }
            // }
          }
          // const obj= g.tests.find(el => el.acknowledgedBy)
          // if(obj){
          //   if(this.status === 'Down'){
          //     g.acknowledgedBy = obj.acknowledgedBy || ''
          //     this.bulkAcknowledge(g, g.acknowledgedBy)
          //   }
          // }
          g.downCounts = this.getTotalOutages(g)
          if (g.downCount === 1 && (g.planName !== '(N/A)' && g.planName !== 'Suspended')) {
            // if downCount is 1 then expand the plan
            this.openedGroups.push(g.planName)
            g.showTests = this.openedGroups.includes(g.planName)
          }
        }
        g.status = g.tests.find(el => el.status === 'down') ? 'down' : 'paused'

      });
      if (this.status !== 'up') {
        // this.testGroups.sort((group1, group2) => (group1.downCount < group2.downCount) ? 1 : -1);
        this.testGroups = _.orderBy(this.testGroups, ['downCount'], ['desc']);
      }
      this.loading = false
      console.log('groups', this.testGroups)
      this.renderDatatable({}, 'ungrouped')
      // this.$nextTick(() => {
      //   console.log('disposing')
      //   // Dispose of old tooltips to avoid duplication
      //   $('[data-toggle="tooltip"]').tooltip('dispose');
      //
      //   // Reinitialize tooltips
      //   $(function () {
      //     $('[data-toggle="tooltip"]').tooltip()
      //   })
      // });
    }
  },
  beforeDestroy() {
    clearInterval(this.timeInterval)
    if (this.pendingJobListener) {
      this.pendingJobListener()
    }
    if (this.migrationListener) {
      this.migrationListener()
    }
    if (this.completeJobListener) {
      this.completeJobListener()
    }
  }
}
</script>

<style scoped>
table {
  min-height: 120px !important;
  border-collapse: unset !important;
}

table td.domain {
  min-width: 100px; /* Adjust the minimum width as per your requirement */
  max-width: 0;
  text-overflow: revert;
}

.dropdown-toggle:after {
  display: none;
}

.sc-status {
  width: 20px;
  border-radius: 50%;
  height: 20px;
  display: inline-block;
}

.sc-status.down {
  background-color: #a51f1f;
}

.sc-status.up {
  background-color: #6aa529;
}

.sc-status.pause {
  background-color: #f29f3f;
}

.sc-status.pending {
  background-color: #66615B;
}

.details-control {
  background: url('../../../assets/img/details_open.png') no-repeat center center;
  cursor: pointer;
  width: 20px;
  height: 20px;
  display: block;
  margin: 13px auto;
}

.details-control.shown {
  width: 15px !important;
  background: url('../../../assets/img/details_close.png') no-repeat center center;
}

.single-outage-table tr > th, td {
  padding: 4px 4px !important;
}

.single-outage-table tr > th {
  font-size: 12px !important;
  font-weight: 400 !important;
}

code {
  color: #007bff !important;
}

.eventsTable tbody tr td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.notesTable tbody tr td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.lh-3 {
  line-height: 3;
}

.group-section {
  background: #f4f4f4;
}

.pagination {
  display: inline-flex !important;
}

.cursor-pointer {
  cursor: pointer !important;
}

.badge.p-4-4 {
  padding: 3px 3px !important;
  border-radius: 0px;
}

.down-monitor-bg {
  background-color: #F9BFB3 !important;
}

.bg-light {
  background-color: rgba(251, 198, 88, 0.1) !important;
}

.w-8 {
  width: 8%;
  height: 8%;
}

.w-6 {
  width: 6%;
  height: 6%;
}

.w-25 {
  width: 20% !important;
  height: 20% !important;
}

.fs-20 {
  font-size: 20px;
}

.settinds-btn, .settinds-btn:active, .settinds-btn:focus {
  background-color: transparent !important;
  color: black !important;
}

.settinds-btn:hover {
  background-color: black !important;
  color: white !important;
}

.filter-btn, .filter-btn:active, .filter-btn:focus {
  background-color: transparent !important;
  color: black !important;
}

.filter-btn:hover {
  background-color: black !important;
  color: white !important;
}

.table-responsive {
  padding-bottom: 50px !important;
}

.text-uppercase {
  text-transform: uppercase;
}

.badge {
  text-transform: capitalize !important;
  font-weight: 600 !important;
}

.managedWP {
  background: #99a728e3;
  border-color: #99a728e3;
}

.vps {
  background: #ff7207;
  border-color: #ff7207;
}

.mediavinePlan1 {
  background: #41A4AA;
  border-color: #41A4AA;
}

.journey {
  background: #004454;
  border-color: #004454;
}

.business {
  background: #f6abab;
  border-color: #f6abab;
}
.datacenter {
  text-transform: uppercase;
  text-align: center;
}
</style>
